const _A = "Assistant";
const _AAD = "AssignmentAssistantData";
const _AC = "AssistantConversation";
const _ACs = "AssistantConversations";
const _AD = "AssistantData";
const _AICSTSO = "AutoInstallCodeStructureTestStepOutput";
const _AIFSO = "AutoInstallFlake8StepOutput";
const _AIJNSO = "AutoInstallJupyterNotebookStepOutput";
const _AIPSO = "AutoInstallPytestStepOutput";
const _AISPTSO = "AutoInstallSimplePythonTestStepOutput";
const _AM = "AssistantMessage";
const _AMAC = "AssistantMessageAssistantContent";
const _AMAD = "AssistantMessageAssistantData";
const _AMC = "AssistantMessageContext";
const _AMCB = "AssistantMessageContentBlocks";
const _AMCBs = "AssistantMessageContentBlock";
const _AMD = "AssistantMessageData";
const _AMDS = "AssistantMessageDetailsSummary";
const _AMESC = "AssistantMessageEditorSessionContext";
const _AMGR = "AssistantMessageGuardrailResult";
const _AMJNC = "AssistantMessageJupyterNotebookContent";
const _AMQQC = "AssistantMessageQuizQuestionContext";
const _AMSG = "AssistantMessageStopGuardrails";
const _AMSMT = "AssistantMessageStopMaxTokens";
const _AMSR = "AssistantMessageStopReason";
const _AMTB = "AssistantMessageThinkingBlock";
const _AMTUB = "AssistantMessageToolUseBlock";
const _AMUC = "AssistantMessageUserContent";
const _AMUD = "AssistantMessageUserData";
const _AMs = "AssistantMessages";
const _AS = "AssistantStatus";
const _ATAICO = "AutoTestAutoInstallConfigurationOutput";
const _ATAISI = "AutoTestAllowInternetStepInput";
const _ATAISO = "AutoTestAllowInternetStepOutput";
const _ATAISOu = "AutoTestAutoInstallStepsOutput";
const _ATAISOut = "AutoTestAutoInstallStepOutput";
const _ATC = "AutoTestConfiguration";
const _ATCQSI = "AutoTestCodingQuestionStepInput";
const _ATCQSO = "AutoTestCodingQuestionStepOutput";
const _ATCRSI = "AutoTestConnectRubricStepInput";
const _ATCRSO = "AutoTestConnectRubricStepOutput";
const _ATCSI = "AutoTestCheckstyleStepInput";
const _ATCSO = "AutoTestCheckstyleStepOutput";
const _ATCSS = "AutoTestCopiedSnapshotSource";
const _ATCSTSI = "AutoTestCodeStructureTestStepInput";
const _ATCSTSO = "AutoTestCodeStructureTestStepOutput";
const _ATCTSI = "AutoTestCustomTestStepInput";
const _ATCTSO = "AutoTestCustomTestStepOutput";
const _ATD = "AutoTestDeductions";
const _ATDNOC = "AutoTestDoNotOverwriteCase";
const _ATDOC = "AutoTestDoOverwriteCase";
const _ATDu = "AutoTestDescription";
const _ATFSI = "AutoTestFlake8StepInput";
const _ATFSO = "AutoTestFlake8StepOutput";
const _ATICSI = "AutoTestInstallClangStepInput";
const _ATICSO = "AutoTestInstallClangStepOutput";
const _ATIDSI = "AutoTestInstallDotnetStepInput";
const _ATIDSO = "AutoTestInstallDotnetStepOutput";
const _ATIGSI = "AutoTestInstallGccStepInput";
const _ATIGSO = "AutoTestInstallGccStepOutput";
const _ATIJSI = "AutoTestInstallJavaStepInput";
const _ATIJSO = "AutoTestInstallJavaStepOutput";
const _ATINSI = "AutoTestInstallNodeStepInput";
const _ATINSO = "AutoTestInstallNodeStepOutput";
const _ATIPSI = "AutoTestInstallPythonStepInput";
const _ATIPSO = "AutoTestInstallPythonStepOutput";
const _ATIRSI = "AutoTestInstallRStepInput";
const _ATIRSO = "AutoTestInstallRStepOutput";
const _ATITSI = "AutoTestIoTestStepInput";
const _ATITSO = "AutoTestIoTestStepOutput";
const _ATJCSI = "AutoTestJavaCompileStepInput";
const _ATJCSO = "AutoTestJavaCompileStepOutput";
const _ATJNSI = "AutoTestJupyterNotebookStepInput";
const _ATJNSO = "AutoTestJupyterNotebookStepOutput";
const _ATJSI = "AutoTestJunit5StepInput";
const _ATJSO = "AutoTestJunit5StepOutput";
const _ATJTF = "AutoTestJunit5TestFile";
const _ATMA = "AutoTestMcqAnswers";
const _ATMAV = "AutoTestMcqAnswersValue";
const _ATMSI = "AutoTestMcqStepInput";
const _ATMSO = "AutoTestMcqStepOutput";
const _ATNMSI = "AutoTestNegativeMatchStepInput";
const _ATNMSO = "AutoTestNegativeMatchStepOutput";
const _ATOR = "AutoTestOverwriteRubric";
const _ATOSI = "AutoTestOutputStepInput";
const _ATOSO = "AutoTestOutputStepOutput";
const _ATPEQSI = "AutoTestPromptEngineeringQuestionStepInput";
const _ATPEQSO = "AutoTestPromptEngineeringQuestionStepOutput";
const _ATPMSI = "AutoTestPositiveMatchStepInput";
const _ATPMSO = "AutoTestPositiveMatchStepOutput";
const _ATPS = "AutoTestPublishedSnapshot";
const _ATPSI = "AutoTestProgramStepInput";
const _ATPSIu = "AutoTestPytestStepInput";
const _ATPSIut = "AutoTestPublishedSnapshotId";
const _ATPSO = "AutoTestProgramStepOutput";
const _ATPSOu = "AutoTestPytestStepOutput";
const _ATPUFO = "AutoTestPartialUploadedFileOutput";
const _ATPUFOu = "AutoTestPartialUploadedFilesOutput";
const _ATQSI = "AutoTestQuizStepInput";
const _ATQSO = "AutoTestQuizStepOutput";
const _ATRAISO = "AutoTestRedactedAllowInternetStepOutput";
const _ATRB = "AutoTestRedactedBoolean";
const _ATRCQSO = "AutoTestRedactedCodingQuestionStepOutput";
const _ATRCRSO = "AutoTestRedactedConnectRubricStepOutput";
const _ATRCS = "AutoTestRedactedCaseSensitivity";
const _ATRCSO = "AutoTestRedactedCheckstyleStepOutput";
const _ATRCSTSO = "AutoTestRedactedCodeStructureTestStepOutput";
const _ATRCSTV = "AutoTestRedactedCodeStructureTestVersion";
const _ATRCTSO = "AutoTestRedactedCustomTestStepOutput";
const _ATRCV = "AutoTestRedactedCheckstyleVersion";
const _ATRD = "AutoTestRedactedDeductions";
const _ATRF = "AutoTestRedactedFraction";
const _ATRFSO = "AutoTestRedactedFlake8StepOutput";
const _ATRFV = "AutoTestRedactedFlake8Version";
const _ATRI = "AutoTestRedactedInteger";
const _ATRIC = "AutoTestRunIfCondition";
const _ATRINSI = "AutoTestRunInNotebookStepInput";
const _ATRINSO = "AutoTestRunInNotebookStepOutput";
const _ATRISI = "AutoTestRunIfStepInput";
const _ATRISIu = "AutoTestRunInStepInput";
const _ATRISO = "AutoTestRunIfStepOutput";
const _ATRISOu = "AutoTestRunInStepOutput";
const _ATRITSO = "AutoTestRedactedIoTestStepOutput";
const _ATRJCSO = "AutoTestRedactedJavaCompileStepOutput";
const _ATRJNSO = "AutoTestRedactedJupyterNotebookStepOutput";
const _ATRJSO = "AutoTestRedactedJunit5StepOutput";
const _ATRJTF = "AutoTestRedactedJunit5TestFile";
const _ATRMA = "AutoTestRedactedMcqAnswers";
const _ATRMAV = "AutoTestRedactedMcqAnswersValue";
const _ATRMSI = "AutoTestRegexMatchStepInput";
const _ATRMSO = "AutoTestRedactedMcqStepOutput";
const _ATRMSOu = "AutoTestRegexMatchStepOutput";
const _ATRNMSO = "AutoTestRedactedNegativeMatchStepOutput";
const _ATROSO = "AutoTestRedactedOutputStepOutput";
const _ATRPD = "AutoTestRedactedPositiveDuration";
const _ATRPEQSO = "AutoTestRedactedPromptEngineeringQuestionStepOutput";
const _ATRPMSO = "AutoTestRedactedPositiveMatchStepOutput";
const _ATRPSO = "AutoTestRedactedProgramStepOutput";
const _ATRPSOu = "AutoTestRedactedPytestStepOutput";
const _ATRQSO = "AutoTestRedactedQuizStepOutput";
const _ATRRIC = "AutoTestRedactedRunIfCondition";
const _ATRRINIM = "AutoTestRedactedRunInNotebookInsertMethod";
const _ATRRINSO = "AutoTestRedactedRunInNotebookStepOutput";
const _ATRRISO = "AutoTestRedactedRunIfStepOutput";
const _ATRRISOu = "AutoTestRedactedRunInStepOutput";
const _ATRRMSO = "AutoTestRedactedRegexMatchStepOutput";
const _ATRS = "AutoTestRedactedString";
const _ATRSAQA = "AutoTestRedactedSelectAllQuestionAnswers";
const _ATRSAQAV = "AutoTestRedactedSelectAllQuestionAnswersValue";
const _ATRSAQAVH = "AutoTestRedactedSelectAllQuestionAnswersValueHints";
const _ATRSAQSO = "AutoTestRedactedSelectAllQuestionStepOutput";
const _ATRSMSO = "AutoTestRedactedSimpleMatchStepOutput";
const _ATRSMSOu = "AutoTestRedactedSubstringMatchStepOutput";
const _ATRSPTSO = "AutoTestRedactedSimplePythonTestStepOutput";
const _ATRSS = "AutoTestRanSnapshotSource";
const _ATRSSO = "AutoTestRedactedSnapshotStepOutput";
const _ATRTCO = "AutoTestRedactedTestConfigurationOutput";
const _ATRTHSO = "AutoTestRedactedTestHideStepOutput";
const _ATRTSO = "AutoTestRedactedTestStepsOutput";
const _ATRTSOu = "AutoTestRedactedTestStepOutput";
const _ATRTTESO = "AutoTestRedactedTestTimeoutEachStepOutput";
const _ATRTUFSO = "AutoTestRedactedTestUploadFilesStepOutput";
const _ATRUFO = "AutoTestRedactedUploadedFilesOutput";
const _ATRWP = "AutoTestRedactedWhitespacesPolicy";
const _ATRWSO = "AutoTestRedactedWeightStepOutput";
const _ATS = "AutoTestSnapshot";
const _ATSAQA = "AutoTestSelectAllQuestionAnswers";
const _ATSAQAV = "AutoTestSelectAllQuestionAnswersValue";
const _ATSAQAVH = "AutoTestSelectAllQuestionAnswersValueHints";
const _ATSAQSI = "AutoTestSelectAllQuestionStepInput";
const _ATSAQSO = "AutoTestSelectAllQuestionStepOutput";
const _ATSBP = "AutoTestSnapshotBuildProgram";
const _ATSCI = "AutoTestSetupConfigurationInput";
const _ATSCO = "AutoTestSetupConfigurationOutput";
const _ATSM = "AutoTestSetupMetadata";
const _ATSMSI = "AutoTestSimpleMatchStepInput";
const _ATSMSIu = "AutoTestSubstringMatchStepInput";
const _ATSMSO = "AutoTestSimpleMatchStepOutput";
const _ATSMSOu = "AutoTestSubstringMatchStepOutput";
const _ATSPTSI = "AutoTestSimplePythonTestStepInput";
const _ATSPTSO = "AutoTestSimplePythonTestStepOutput";
const _ATSS = "AutoTestSnapshotSummary";
const _ATSSI = "AutoTestScriptStepInput";
const _ATSSIu = "AutoTestSnapshotStepInput";
const _ATSSIut = "AutoTestSetupStepsInput";
const _ATSSIuto = "AutoTestSetupStepInput";
const _ATSSO = "AutoTestScriptStepOutput";
const _ATSSOu = "AutoTestSnapshotStepOutput";
const _ATSSOut = "AutoTestSetupStepsOutput";
const _ATSSOuto = "AutoTestSetupStepOutput";
const _ATSSu = "AutoTestSnapshotSummaries";
const _ATSSut = "AutoTestSnapshotSource";
const _ATTCI = "AutoTestTestConfigurationInput";
const _ATTCO = "AutoTestTestConfigurationOutput";
const _ATTHSI = "AutoTestTestHideStepInput";
const _ATTHSO = "AutoTestTestHideStepOutput";
const _ATTSI = "AutoTestTestStepsInput";
const _ATTSIu = "AutoTestTestStepInput";
const _ATTSO = "AutoTestTestStepsOutput";
const _ATTSOu = "AutoTestTestStepOutput";
const _ATTTESI = "AutoTestTestTimeoutEachStepInput";
const _ATTTESO = "AutoTestTestTimeoutEachStepOutput";
const _ATTUFSI = "AutoTestTestUploadFilesStepInput";
const _ATTUFSO = "AutoTestTestUploadFilesStepOutput";
const _ATUFI = "AutoTestUploadedFileInput";
const _ATUFIu = "AutoTestUploadedFilesInput";
const _ATUFO = "AutoTestUploadedFileOutput";
const _ATUFOu = "AutoTestUploadedFilesOutput";
const _ATUFSI = "AutoTestUploadFilesStepInput";
const _ATUFSO = "AutoTestUploadFilesStepOutput";
const _ATWSI = "AutoTestWeightStepInput";
const _ATWSO = "AutoTestWeightStepOutput";
const _As = "Assistants";
const _BRE = "BadRequestError";
const _BRER = "BadRequestErrorReason";
const _CA = "CreateAssistant";
const _CAC = "CreateAssistantConversation";
const _CACR = "CreateAssistantConversationRequest";
const _CACRr = "CreateAssistantConversationResponse";
const _CAM = "CreateAssistantMessage";
const _CAMR = "CreateAssistantMessageRequest";
const _CAMRr = "CreateAssistantMessageResponse";
const _CAR = "CreateAssistantRequest";
const _CARr = "CreateAssistantResponse";
const _CATC = "CopyAutoTestConfiguration";
const _CATCR = "CopyAutoTestConfigurationRequest";
const _CATCRo = "CopyAutoTestConfigurationResponse";
const _CATS = "CreateAutoTestSnapshot";
const _CATSR = "CreateAutoTestSnapshotRequest";
const _CATSRr = "CreateAutoTestSnapshotResponse";
const _CES = "CreateEditorSession";
const _CESR = "CreateEditorSessionRequest";
const _CESRr = "CreateEditorSessionResponse";
const _CIATC = "CompleteImportAutoTestConfiguration";
const _CIATCR = "CompleteImportAutoTestConfigurationRequest";
const _CIATCRC = "CompleteImportAutoTestConfigurationRubricConfiguration";
const _CIATCRo = "CompleteImportAutoTestConfigurationResponse";
const _CSP = "CreateSafeProgram";
const _CSPR = "CreateSafeProgramRequest";
const _CSPRr = "CreateSafeProgramResponse";
const _DATC = "DeleteAutoTestConfiguration";
const _DATCR = "DeleteAutoTestConfigurationRequest";
const _DATCRe = "DeleteAutoTestConfigurationResponse";
const _ED = "EditorDocument";
const _EDd = "EditorDocuments";
const _EEDJC = "ExecuteEditorDocumentJupyterCell";
const _EEDJCR = "ExecuteEditorDocumentJupyterCellRequest";
const _EEDJCRx = "ExecuteEditorDocumentJupyterCellResponse";
const _EFL = "EditorFileList";
const _EFT = "EditorFileType";
const _ES = "EditorSession";
const _ESS = "EditorSessionSource";
const _ESSS = "EditorSessionSubmissionSource";
const _ESTS = "EditorSessionTemplateSource";
const _ESd = "EditorSessions";
const _F = "Fraction";
const _FUET = "FoundUnknownEnumType";
const _G = "Group";
const _GA = "GetAssistant";
const _GAC = "GetAssistantConversation";
const _GACR = "GetAssistantConversationRequest";
const _GACRe = "GetAssistantConversationResponse";
const _GAM = "GetAssistantMessage";
const _GAMR = "GetAssistantMessageRequest";
const _GAMRe = "GetAssistantMessageResponse";
const _GAR = "GetAssistantRequest";
const _GARe = "GetAssistantResponse";
const _GATC = "GetAutoTestConfiguration";
const _GATCR = "GetAutoTestConfigurationRequest";
const _GATCRe = "GetAutoTestConfigurationResponse";
const _GATPS = "GetAutoTestPublishedSnapshot";
const _GATPSR = "GetAutoTestPublishedSnapshotRequest";
const _GATPSRe = "GetAutoTestPublishedSnapshotResponse";
const _GATRR = "GetAutoTestRubricResults";
const _GATRRR = "GetAutoTestRubricResultsRequest";
const _GATRRRe = "GetAutoTestRubricResultsResponse";
const _GATS = "GetAutoTestSnapshot";
const _GATSR = "GetAutoTestSnapshotRequest";
const _GATSRe = "GetAutoTestSnapshotResponse";
const _GED = "GetEditorDocument";
const _GEDR = "GetEditorDocumentRequest";
const _GEDRe = "GetEditorDocumentResponse";
const _GEFDL = "GetEditorFileDownloadLink";
const _GEFDLR = "GetEditorFileDownloadLinkRequest";
const _GEFDLRe = "GetEditorFileDownloadLinkResponse";
const _GES = "GetEditorSession";
const _GESR = "GetEditorSessionRequest";
const _GESRe = "GetEditorSessionResponse";
const _GM = "GroupMembers";
const _GPCT = "GetPearsonContextTemplate";
const _GPCTQ = "GetPearsonContextTemplateQuestion";
const _GPCTQR = "GetPearsonContextTemplateQuestionRequest";
const _GPCTQRe = "GetPearsonContextTemplateQuestionResponse";
const _GPCTR = "GetPearsonContextTemplateRequest";
const _GPCTRe = "GetPearsonContextTemplateResponse";
const _GU = "GroupUser";
const _HIES = "HandInEditorSession";
const _HIESR = "HandInEditorSessionRequest";
const _HIESRa = "HandInEditorSessionResponse";
const _IEDJK = "InterruptEditorDocumentJupyterKernel";
const _IEDJKR = "InterruptEditorDocumentJupyterKernelRequest";
const _IEDJKRn = "InterruptEditorDocumentJupyterKernelResponse";
const _IEDT = "InputEditorDirectoryType";
const _IFT = "InputFileType";
const _INIQ = "IgnoreNonInteractedQuestions";
const _IPER = "InvalidParamErrorReason";
const _IPT = "InstantiatePearsonTemplate";
const _IPTR = "InstantiatePearsonTemplateRequest";
const _IPTRn = "InstantiatePearsonTemplateResponse";
const _IRFT = "InputRegularFileType";
const _IROR = "InexplicitRubricOverwriteReason";
const _ISE = "InternalServerError";
const _ISER = "InvalidStateErrorReason";
const _JDDOE = "JupyterDisplayDataOutputEvent";
const _JEIOE = "JupyterExecuteInterruptedOutputEvent";
const _JEOE = "JupyterErrorOutputEvent";
const _JEROE = "JupyterExecuteReqeustedOutputEvent";
const _JEROEu = "JupyterExecuteResultOutputEvent";
const _JESOE = "JupyterExecuteStartOutputEvent";
const _JK = "JupyterKernel";
const _JKA = "JupyterKernelAlive";
const _JKD = "JupyterKernelDead";
const _JKS = "JupyterKernelStarting";
const _JKSu = "JupyterKernelStatus";
const _JMODE = "JupyterMimeOutputDataEvent";
const _JMODEV = "JupyterMimeOutputDataEventValue";
const _JMODEVL = "JupyterMimeOutputDataEventValueLink";
const _JO = "JupyterOutput";
const _JOE = "JupyterOutputEvent";
const _JOu = "JupyterOutputs";
const _JSOE = "JupyterStreamOutputEvent";
const _JSOEV = "JupyterStreamOutputEventValue";
const _JSOEVL = "JupyterStreamOutputEventValueLink";
const _LAA = "ListAssignmentAssistants";
const _LAAR = "ListAssignmentAssistantsRequest";
const _LAARi = "ListAssignmentAssistantsResponse";
const _LAM = "ListAssistantMessages";
const _LAMD = "ListAssistantMessageDetails";
const _LAMDR = "ListAssistantMessageDetailsRequest";
const _LAMDRi = "ListAssistantMessageDetailsResponse";
const _LAMR = "ListAssistantMessagesRequest";
const _LAMRi = "ListAssistantMessagesResponse";
const _LATS = "ListAutoTestSnapshots";
const _LATSR = "ListAutoTestSnapshotsRequest";
const _LATSRi = "ListAutoTestSnapshotsResponse";
const _LED = "ListEditorDocuments";
const _LEDJCO = "ListEditorDocumentJupyterCellOutputs";
const _LEDJCOR = "ListEditorDocumentJupyterCellOutputsRequest";
const _LEDJCORi = "ListEditorDocumentJupyterCellOutputsResponse";
const _LEDR = "ListEditorDocumentsRequest";
const _LEDRi = "ListEditorDocumentsResponse";
const _LES = "ListEditorSessions";
const _LESR = "ListEditorSessionsRequest";
const _LESRi = "ListEditorSessionsResponse";
const _LUAC = "ListUserAssistantConversations";
const _LUACR = "ListUserAssistantConversationsRequest";
const _LUACRi = "ListUserAssistantConversationsResponse";
const _NAE = "NotAuthenticatedError";
const _NAEo = "NotAuthorizedError";
const _NFE = "NotFoundError";
const _NOA = "NumberOfAttempts";
const _NU = "NormalUser";
const _OEDT = "OutputEditorDirectoryType";
const _OEF = "OutputEditorFile";
const _OJNFT = "OutputJupyterNotebookFileType";
const _ORBFT = "OutputRegularBinaryFileType";
const _ORFT = "OuptutRegularFileType";
const _ORQFT = "OutputRegularQuizFileType";
const _ORTFT = "OutputRegularTextFileType";
const _PATC = "PutAutoTestConfiguration";
const _PATCR = "PutAutoTestConfigurationRequest";
const _PATCRu = "PutAutoTestConfigurationResponse";
const _PCQD = "PearsonCodingQuestionData";
const _PCT = "PearsonContextTemplate";
const _PCTQ = "PearsonContextTemplateQuestion";
const _PCTQR = "PearsonContextTemplateQuestionReference";
const _PCTQS = "PearsonContextTemplateQuestionSummary";
const _PCTQSe = "PearsonContextTemplateQuestionSummaries";
const _PEF = "PutEditorFile";
const _PEFR = "PutEditorFileRequest";
const _PEFRu = "PutEditorFileResponse";
const _PMCQA = "PearsonMultipleChoiceQuestionAnswer";
const _PMCQAe = "PearsonMultipleChoiceQuestionAnswers";
const _PMCQD = "PearsonMultipleChoiceQuestionData";
const _PPB = "PutPearsonBook";
const _PPBR = "PutPearsonBookRequest";
const _PPBRu = "PutPearsonBookResponse";
const _PPCQS = "PutPearsonCodingQuestionSource";
const _PPCT = "PutPearsonContextTemplate";
const _PPCTR = "PutPearsonContextTemplateRequest";
const _PPCTRu = "PutPearsonContextTemplateResponse";
const _PPQ = "PutPearsonQuestion";
const _PPQR = "PutPearsonQuestionRequest";
const _PPQRu = "PutPearsonQuestionResponse";
const _PPQS = "PutPearsonQuestionSource";
const _PPT = "PutPearsonTemplate";
const _PPTR = "PutPearsonTemplateRequest";
const _PPTRu = "PutPearsonTemplateResponse";
const _PQD = "PearsonQuestionData";
const _PSAQA = "PearsonSelectAllQuestionAnswer";
const _PSAQAH = "PearsonSelectAllQuestionAnswerHints";
const _PSAQAe = "PearsonSelectAllQuestionAnswers";
const _PSAQD = "PearsonSelectAllQuestionData";
const _RM = "RubricMapping";
const _RML = "RubricMappingList";
const _SP = "SafeProgram";
const _SPPQS = "SafeProgramPearsonQuestionSource";
const _SPS = "SafeProgramSource";
const _SPSQQS = "SafeProgramSingleQuizQuestionSource";
const _SPSS = "SafeProgramSubmissionSource";
const _SR = "SubmissionReference";
const _TRER = "TierRestrictedErrorReason";
const _U = "User";
const _UA = "UpdateAssistant";
const _UAR = "UpdateAssistantRequest";
const _UARp = "UpdateAssistantResponse";
const _UATC = "UpdateAutoTestConfiguration";
const _UATCR = "UpdateAutoTestConfigurationRequest";
const _UATCRp = "UpdateAutoTestConfigurationResponse";
const _UETER = "UnknownEnumTypeErrorReason";
const _UPCT = "UpdatePearsonContextTemplate";
const _UPCTQ = "UpdatePearsonContextTemplateQuestion";
const _UPCTQR = "UpdatePearsonContextTemplateQuestionRequest";
const _UPCTQRp = "UpdatePearsonContextTemplateQuestionResponse";
const _UPCTR = "UpdatePearsonContextTemplateRequest";
const _UPCTRp = "UpdatePearsonContextTemplateResponse";
const _VE = "ValidationError";
const _VEF = "ValidationErrorField";
const _VEFL = "ValidationErrorFieldList";
const _WICER = "WrongItemCountErrorReason";
const _XNT = "X-Next-Token";
const _XPS = "X-Page-Size";
const _XSI = "X-Submission-Ids";
const _a = "action";
const _aF = "answerFilename";
const _aI = "assignmentId";
const _aICST = "autoInstallCodeStructureTest";
const _aIF = "autoInstallFlake8";
const _aIJN = "autoInstallJupyterNotebook";
const _aIP = "autoInstallPytest";
const _aISPT = "autoInstallSimplePythonTest";
const _aIl = "allowInternet";
const _aIs = "assistantId";
const _aIu = "autoInstall";
const _aL = "answerLanguage";
const _aO = "answerOrder";
const _aTS = "autoTestSteps";
const _al = "alive";
const _an = "answer";
const _ans = "answers";
const _as = "assistant";
const _ass = "assistants";
const _assi = "assignment";
const _au = "author";
const _b = "blocks";
const _bAI = "buildAssignmentId";
const _bI = "bookId";
const _bII = "baseImageId";
const _bP = "buildProgram";
const _be = "behavior";
const _bi = "binary";
const _c = "client";
const _cA = "createdAt";
const _cAo = "correctAnswer";
const _cC = "cellContent";
const _cI = "conversationId";
const _cIe = "cellId";
const _cIo = "contextId";
const _cQ = "codingQuestion";
const _cR = "connectRubric";
const _cS = "caseSensitivity";
const _cST = "codeStructureTest";
const _cT = "contentType";
const _cTo = "contextTemplate";
const _cTu = "customTest";
const _ch = "children";
const _che = "checkstyle";
const _co = "content";
const _cod = "code";
const _codi = "coding";
const _con = "context";
const _cond = "condition";
const _conf = "config";
const _confi = "configuration";
const _cont = "contents";
const _conv = "conversation";
const _conve = "conversations";
const _cop = "copied";
const _cor = "correct";
const _d = "description";
const _dAI = "dstAssignmentId";
const _dD = "displayData";
const _dI = "documentId";
const _dIi = "displayId";
const _dNO = "doNotOverwrite";
const _dO = "doOverwrite";
const _dRRI = "destinationRubricRowId";
const _dS = "detailsSummary";
const _da = "data";
const _de = "deductions";
const _dea = "dead";
const _den = "denominator";
const _di = "disabled";
const _dir = "directory";
const _do = "document";
const _doc = "documents";
const _e = "error";
const _eC = "executionCount";
const _eI = "executeInterrupted";
const _eR = "executeResult";
const _eRx = "executeRequested";
const _eS = "editorSession";
const _eSI = "editorSessionId";
const _eSd = "editorSubmission";
const _eSdi = "editorSessions";
const _eSx = "executeStart";
const _eT = "endTurn";
const _en = "environment";
const _ena = "enabled";
const _ev = "event";
const _f = "features";
const _fL = "fieldList";
const _fN = "fileName";
const _fT = "fileType";
const _fTI = "fileTreeId";
const _fi = "files";
const _fil = "file";
const _file = "filename";
const _fl = "flake8";
const _fo = "found";
const _g = "guardrails";
const _gR = "guardrailResult";
const _gRu = "guardRails";
const _gSI = "groupSetId";
const _gr = "group";
const _h = "hint";
const _hE = "httpError";
const _hH = "httpHeader";
const _hQ = "httpQuery";
const _hT = "hasThinking";
const _hTU = "hasToolUse";
const _hTi = "hideType";
const _hi = "hints";
const _ht = "http";
const _i = "id";
const _iC = "isCorrect";
const _iCn = "installClang";
const _iD = "installDotnet";
const _iG = "installGcc";
const _iJ = "installJava";
const _iM = "initialMessage";
const _iMn = "insertMethod";
const _iN = "installNode";
const _iNIQ = "ignoreNonInteractedQuestions";
const _iP = "installPython";
const _iPn = "invalidParam";
const _iR = "installR";
const _iRO = "inexplicitRubricOverwrite";
const _iS = "invalidState";
const _iT = "inputText";
const _iTS = "isTestStudent";
const _iTo = "ioTest";
const _in = "info";
const _inc = "incorrect";
const _inl = "inline";
const _j = "junit5";
const _jC = "javaCompile";
const _jN = "jupyterNotebook";
const _jNI = "jupyterNotebookId";
const _jOI = "jupyterOutputId";
const _jQ = "jupyterQuestion";
const _k = "kernel";
const _kI = "kernelId";
const _l = "level";
const _lI = "lockId";
const _la = "language";
const _li = "link";
const _lim = "limited";
const _m = "message";
const _mA = "maximumAllowed";
const _mAi = "minimumAllowed";
const _mC = "multipleChoice";
const _mD = "mimeData";
const _mI = "messageId";
const _mP = "minimumPercentage";
const _mT = "maxTokens";
const _ma = "mapping";
const _mc = "mcq";
const _me = "messages";
const _mem = "members";
const _met = "metadata";
const _mo = "model";
const _n = "name";
const _nM = "negativeMatch";
const _nOA = "numberOfAttempts";
const _nT = "nextToken";
const _no = "normal";
const _not = "notebook";
const _nu = "numerator";
const _o = "operation";
const _oR = "overwriteRubric";
const _oT = "outputText";
const _ou = "outputs";
const _out = "output";
const _ow = "owner";
const _p = "path";
const _pEQ = "promptEngineeringQuestion";
const _pI = "programId";
const _pKV = "python3KernelVersion";
const _pM = "positiveMatch";
const _pQ = "pearsonQuestion";
const _pS = "pageSize";
const _pSu = "publishedSnapshot";
const _pr = "preposition";
const _pro = "program";
const _pu = "published";
const _py = "pytest";
const _q = "question";
const _qI = "questionId";
const _qM = "questionsMapping";
const _qQ = "quizQuestion";
const _qu = "questions";
const _qui = "quiz";
const _r = "reason";
const _rA = "restrictedAddons";
const _rC = "rubricConfiguration";
const _rI = "requestId";
const _rIN = "runInNotebook";
const _rIu = "runIn";
const _rIun = "runIf";
const _rM = "regexMatch";
const _rP = "runPermission";
const _rR = "rubricResults";
const _rRI = "rubricRowId";
const _rRL = "rubricRowLock";
const _rSQ = "runSingleQuestions";
const _ra = "ran";
const _re = "resource";
const _red = "redacted";
const _reg = "regular";
const _ru = "rules";
const _s = "smithy.ts.sdk.synthetic.com.codegrade";
const _sA = "selectAll";
const _sAQ = "selectAllQuestion";
const _sC = "starterCode";
const _sFN = "studentFileName";
const _sI = "snapshotId";
const _sIu = "submissionIds";
const _sIub = "submissionId";
const _sM = "simpleMatch";
const _sMu = "substringMatch";
const _sP = "systemPrompt";
const _sPT = "simplePythonTest";
const _sPa = "safeProgram";
const _sQQ = "singleQuizQuestion";
const _sR = "stopReason";
const _sRRI = "sourceRubricRowId";
const _sc = "script";
const _se = "server";
const _set = "setup";
const _si = "size";
const _sn = "snapshot";
const _sna = "snapshots";
const _so = "solution";
const _sou = "source";
const _st = "status";
const _sta = "state";
const _star = "starting";
const _ste = "steps";
const _str = "stream";
const _su = "summary";
const _sub = "submission";
const _t = "title";
const _tCI = "targetCellId";
const _tF = "testFile";
const _tFe = "templateFile";
const _tH = "testHide";
const _tI = "tenantId";
const _tIe = "templateId";
const _tR = "tierRestricted";
const _tTE = "testTimeoutEach";
const _tU = "toUpload";
const _tUF = "testUploadFiles";
const _tUo = "toolUse";
const _ta = "tags";
const _te = "test";
const _tem = "template";
const _tex = "text";
const _th = "thinking";
const _ti = "timeout";
const _tr = "traceback";
const _ty = "type";
const _u = "url";
const _uA = "updatedAt";
const _uET = "unknownEnumType";
const _uF = "uploadFiles";
const _uI = "userId";
const _uS = "updatedSetup";
const _uT = "updatedTest";
const _un = "unpublished";
const _unl = "unlimited";
const _unr = "unredacted";
const _us = "username";
const _use = "user";
const _v = "version";
const _vCA = "viewCorrectAnswer";
const _vM = "viewMode";
const _va = "value";
const _w = "where";
const _wIC = "wrongItemCount";
const _wP = "whitespacesPolicy";
const _wa = "warning";
const _we = "weight";
const _wh = "when";
const _wha = "what";
const _xri = "x-request-id";
const _y = "year";
const n0 = "com.codegrade.errors";
const n1 = "com.codegrade.assistant";
const n2 = "com.codegrade.autotest";
const n3 = "com.codegrade.common";
const n4 = "com.codegrade.editor";
const n5 = "com.codegrade.pearson";
const n6 = "com.codegrade.safe";
import { TypeRegistry } from "@smithy/core/schema";
import { Apiv2ServiceException } from "../models/Apiv2ServiceException";
import { BadRequestError, InternalServerError, NotAuthenticatedError, NotAuthorizedError, NotFoundError, ValidationError, } from "../models/errors";
const _s_registry = TypeRegistry.for(_s);
export var Apiv2ServiceException$ = [-3, _s, "Apiv2ServiceException", 0, [], []];
_s_registry.registerError(Apiv2ServiceException$, Apiv2ServiceException);
const n0_registry = TypeRegistry.for(n0);
export var BadRequestError$ = [-3, n0, _BRE,
    { [_e]: _c, [_hE]: 400 },
    [_m, _d, _rI, _r],
    [0, 0, [0, { [_hH]: _xri }], () => BadRequestErrorReason$], 4
];
n0_registry.registerError(BadRequestError$, BadRequestError);
export var InternalServerError$ = [-3, n0, _ISE,
    { [_e]: _se, [_hE]: 500 },
    [_m, _d, _rI],
    [0, 0, [0, { [_hH]: _xri }]], 3
];
n0_registry.registerError(InternalServerError$, InternalServerError);
export var NotAuthenticatedError$ = [-3, n0, _NAE,
    { [_e]: _c, [_hE]: 401 },
    [_m, _d, _rI],
    [0, 0, [0, { [_hH]: _xri }]], 3
];
n0_registry.registerError(NotAuthenticatedError$, NotAuthenticatedError);
export var NotAuthorizedError$ = [-3, n0, _NAEo,
    { [_e]: _c, [_hE]: 403 },
    [_m, _d, _rI, _re, _o],
    [0, 0, [0, { [_hH]: _xri }], 0, 0], 5
];
n0_registry.registerError(NotAuthorizedError$, NotAuthorizedError);
export var NotFoundError$ = [-3, n0, _NFE,
    { [_e]: _c, [_hE]: 404 },
    [_m, _d, _rI, _re],
    [0, 0, [0, { [_hH]: _xri }], 0], 4
];
n0_registry.registerError(NotFoundError$, NotFoundError);
export var ValidationError$ = [-3, n0, _VE,
    { [_e]: _c, [_hE]: 400 },
    [_m, _d, _rI, _fL],
    [0, 0, [0, { [_hH]: _xri }], () => ValidationErrorFieldList], 4
];
n0_registry.registerError(ValidationError$, ValidationError);
export const errorTypeRegistries = [
    _s_registry,
    n0_registry,
];
export var AssignmentAssistantData$ = [3, n1, _AAD,
    0,
    [_aI],
    [0], 1
];
export var Assistant$ = [3, n1, _A,
    0,
    [_aIs, _n, _st, _mo, _g, _da, _sP, _f],
    [0, 0, () => AssistantStatus$, 0, 0, () => AssistantData$, 0, 64 | 0], 6
];
export var AssistantConversation$ = [3, n1, _AC,
    0,
    [_aIs, _cI, _ow, _cA, _t],
    [0, 0, 0, 5, 0], 4
];
export var AssistantMessage$ = [3, n1, _AM,
    0,
    [_aIs, _cI, _mI, _cA, _da],
    [0, 0, 0, 5, () => AssistantMessageData$], 5
];
export var AssistantMessageAssistantData$ = [3, n1, _AMAD,
    0,
    [_co, _dS, _sR, _gR],
    [() => AssistantMessageAssistantContent$, () => AssistantMessageDetailsSummary$, () => AssistantMessageStopReason$, () => AssistantMessageGuardrailResult$], 3
];
export var AssistantMessageContext$ = [3, n1, _AMC,
    0,
    [_eS, _qQ, _jQ],
    [() => AssistantMessageEditorSessionContext$, () => AssistantMessageQuizQuestionContext$, () => AssistantMessageJupyterNotebookContent$]
];
export var AssistantMessageDetailsSummary$ = [3, n1, _AMDS,
    0,
    [_hT, _hTU],
    [2, 2], 2
];
export var AssistantMessageEditorSessionContext$ = [3, n1, _AMESC,
    0,
    [_eSI, _dI],
    [0, 0], 1
];
export var AssistantMessageGuardrailResult$ = [3, n1, _AMGR,
    0,
    [_w, _a],
    [0, 0], 2
];
export var AssistantMessageJupyterNotebookContent$ = [3, n1, _AMJNC,
    0,
    [_jNI],
    [0], 1
];
export var AssistantMessageQuizQuestionContext$ = [3, n1, _AMQQC,
    0,
    [_qI],
    [0], 1
];
export var AssistantMessageStopGuardrails$ = [3, n1, _AMSG,
    0,
    [_l],
    [0], 1
];
export var AssistantMessageStopMaxTokens$ = [3, n1, _AMSMT,
    0,
    [_mT],
    [1], 1
];
export var AssistantMessageThinkingBlock$ = [3, n1, _AMTB,
    0,
    [_co],
    [0], 1
];
export var AssistantMessageToolUseBlock$ = [3, n1, _AMTUB,
    0,
    [_n, _su],
    [0, 0], 2
];
export var AssistantMessageUserData$ = [3, n1, _AMUD,
    0,
    [_co, _au],
    [() => AssistantMessageUserContent$, () => User$], 1
];
export var CreateAssistantConversationRequest$ = [3, n1, _CACR,
    0,
    [_aIs, _ow, _t, _iM, _con],
    [[0, 1], 0, 0, () => AssistantMessageUserContent$, () => AssistantMessageContext$], 2
];
export var CreateAssistantConversationResponse$ = [3, n1, _CACRr,
    0,
    [_conv],
    [[() => AssistantConversation$, 16]], 1
];
export var CreateAssistantMessageRequest$ = [3, n1, _CAMR,
    0,
    [_aIs, _cI, _co, _con],
    [[0, 1], [0, 1], () => AssistantMessageUserContent$, () => AssistantMessageContext$], 3
];
export var CreateAssistantMessageResponse$ = [3, n1, _CAMRr,
    0,
    [_m],
    [[() => AssistantMessage$, 16]], 1
];
export var CreateAssistantRequest$ = [3, n1, _CAR,
    0,
    [_sP, _da, _n, _mo, _g, _st, _f],
    [0, () => AssistantData$, 0, 0, 0, () => AssistantStatus$, 64 | 0], 3
];
export var CreateAssistantResponse$ = [3, n1, _CARr,
    0,
    [_as],
    [[() => Assistant$, 16]], 1
];
export var GetAssistantConversationRequest$ = [3, n1, _GACR,
    0,
    [_aIs, _cI],
    [[0, 1], [0, 1]], 2
];
export var GetAssistantConversationResponse$ = [3, n1, _GACRe,
    0,
    [_conv],
    [[() => AssistantConversation$, 16]], 1
];
export var GetAssistantMessageRequest$ = [3, n1, _GAMR,
    0,
    [_aIs, _cI, _mI],
    [[0, 1], [0, 1], [0, 1]], 3
];
export var GetAssistantMessageResponse$ = [3, n1, _GAMRe,
    0,
    [_m],
    [[() => AssistantMessage$, 16]], 1
];
export var GetAssistantRequest$ = [3, n1, _GAR,
    0,
    [_aIs],
    [[0, 1]], 1
];
export var GetAssistantResponse$ = [3, n1, _GARe,
    0,
    [_as],
    [[() => Assistant$, 16]], 1
];
export var ListAssignmentAssistantsRequest$ = [3, n1, _LAAR,
    0,
    [_aI, _nT, _pS],
    [[0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 1
];
export var ListAssignmentAssistantsResponse$ = [3, n1, _LAARi,
    0,
    [_ass, _nT],
    [() => Assistants, [0, { [_hH]: _XNT }]], 1
];
export var ListAssistantMessageDetailsRequest$ = [3, n1, _LAMDR,
    0,
    [_aIs, _cI, _mI, _nT, _pS],
    [[0, 1], [0, 1], [0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 3
];
export var ListAssistantMessageDetailsResponse$ = [3, n1, _LAMDRi,
    0,
    [_b, _nT],
    [() => AssistantMessageContentBlocks, [0, { [_hH]: _XNT }]], 1
];
export var ListAssistantMessagesRequest$ = [3, n1, _LAMR,
    0,
    [_aIs, _cI, _nT, _pS],
    [[0, 1], [0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 2
];
export var ListAssistantMessagesResponse$ = [3, n1, _LAMRi,
    0,
    [_me, _nT],
    [() => AssistantMessages, [0, { [_hH]: _XNT }]], 1
];
export var ListUserAssistantConversationsRequest$ = [3, n1, _LUACR,
    0,
    [_aI, _uI, _nT, _pS],
    [[0, { [_hQ]: _aI }], [0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 2
];
export var ListUserAssistantConversationsResponse$ = [3, n1, _LUACRi,
    0,
    [_conve, _nT],
    [() => AssistantConversations, [0, { [_hH]: _XNT }]], 1
];
export var UpdateAssistantRequest$ = [3, n1, _UAR,
    0,
    [_aIs, _sP, _n, _st, _f, _mo, _g],
    [[0, 1], 0, 0, () => AssistantStatus$, 64 | 0, 0, 0], 1
];
export var UpdateAssistantResponse$ = [3, n1, _UARp,
    0,
    [_as],
    [[() => Assistant$, 16]], 1
];
export var AutoInstallCodeStructureTestStepOutput$ = [3, n2, _AICSTSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoInstallFlake8StepOutput$ = [3, n2, _AIFSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoInstallJupyterNotebookStepOutput$ = [3, n2, _AIJNSO,
    0,
    [_i, _k, _pKV],
    [0, 0, 0], 3
];
export var AutoInstallPytestStepOutput$ = [3, n2, _AIPSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoInstallSimplePythonTestStepOutput$ = [3, n2, _AISPTSO,
    0,
    [_i],
    [0], 1
];
export var AutoTestAllowInternetStepInput$ = [3, n2, _ATAISI,
    0,
    [_i, _ch],
    [0, () => AutoTestTestStepsInput]
];
export var AutoTestAllowInternetStepOutput$ = [3, n2, _ATAISO,
    0,
    [_i, _ch],
    [0, () => AutoTestTestStepsOutput], 2
];
export var AutoTestAutoInstallConfigurationOutput$ = [3, n2, _ATAICO,
    0,
    [_ste],
    [() => AutoTestAutoInstallStepsOutput], 1
];
export var AutoTestCheckstyleStepInput$ = [3, n2, _ATCSI,
    0,
    [_conf, _fi, _v, _de, _i, _n, _d],
    [0, 0, 0, () => AutoTestDeductions$, 0, 0, () => AutoTestDescription$], 4
];
export var AutoTestCheckstyleStepOutput$ = [3, n2, _ATCSO,
    0,
    [_i, _n, _d, _conf, _fi, _v, _de],
    [0, 0, () => AutoTestDescription$, 0, 0, 0, () => AutoTestDeductions$], 7
];
export var AutoTestCodeStructureTestStepInput$ = [3, n2, _ATCSTSI,
    0,
    [_fil, _v, _i, _n, _ch],
    [0, 0, 0, 0, () => AutoTestTestStepsInput], 2
];
export var AutoTestCodeStructureTestStepOutput$ = [3, n2, _ATCSTSO,
    0,
    [_i, _n, _ch, _fil, _v],
    [0, 0, () => AutoTestTestStepsOutput, 0, 0], 5
];
export var AutoTestCodingQuestionStepInput$ = [3, n2, _ATCQSI,
    0,
    [_sFN, _q, _sC, _i, _n, _ch, _so],
    [0, 0, 0, 0, 0, () => AutoTestTestStepsInput, 0], 3
];
export var AutoTestCodingQuestionStepOutput$ = [3, n2, _ATCQSO,
    0,
    [_i, _n, _ch, _sFN, _q, _sC, _so],
    [0, 0, () => AutoTestTestStepsOutput, 0, 0, 0, 0], 6
];
export var AutoTestConfiguration$ = [3, n2, _ATC,
    0,
    [_aI, _set, _te, _pSu],
    [0, () => AutoTestSetupConfigurationOutput$, () => AutoTestTestConfigurationOutput$, () => AutoTestPublishedSnapshotId$], 4
];
export var AutoTestConnectRubricStepInput$ = [3, n2, _ATCRSI,
    0,
    [_i, _ch, _rRI],
    [0, () => AutoTestTestStepsInput, 1]
];
export var AutoTestConnectRubricStepOutput$ = [3, n2, _ATCRSO,
    0,
    [_i, _ch, _rRI],
    [0, () => AutoTestTestStepsOutput, 1], 2
];
export var AutoTestCopiedSnapshotSource$ = [3, n2, _ATCSS,
    0,
    [_sI, _aI],
    [0, 0]
];
export var AutoTestCustomTestStepInput$ = [3, n2, _ATCTSI,
    0,
    [_sc, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestCustomTestStepOutput$ = [3, n2, _ATCTSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestDeductions$ = [3, n2, _ATD,
    0,
    [_e, _wa, _in],
    [1, 1, 1], 3
];
export var AutoTestDescription$ = [3, n2, _ATDu,
    0,
    [_va, _be],
    [0, 0], 2
];
export var AutoTestDoNotOverwriteCase$ = [3, n2, _ATDNOC,
    0,
    [],
    []
];
export var AutoTestDoOverwriteCase$ = [3, n2, _ATDOC,
    0,
    [],
    []
];
export var AutoTestFlake8StepInput$ = [3, n2, _ATFSI,
    0,
    [_conf, _fil, _v, _de, _i, _n, _d],
    [0, 0, 0, () => AutoTestDeductions$, 0, 0, () => AutoTestDescription$], 4
];
export var AutoTestFlake8StepOutput$ = [3, n2, _ATFSO,
    0,
    [_i, _n, _d, _conf, _fil, _v, _de],
    [0, 0, () => AutoTestDescription$, 0, 0, 0, () => AutoTestDeductions$], 7
];
export var AutoTestInstallClangStepInput$ = [3, n2, _ATICSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallClangStepOutput$ = [3, n2, _ATICSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestInstallDotnetStepInput$ = [3, n2, _ATIDSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallDotnetStepOutput$ = [3, n2, _ATIDSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestInstallGccStepInput$ = [3, n2, _ATIGSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallGccStepOutput$ = [3, n2, _ATIGSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestInstallJavaStepInput$ = [3, n2, _ATIJSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallJavaStepOutput$ = [3, n2, _ATIJSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestInstallNodeStepInput$ = [3, n2, _ATINSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallNodeStepOutput$ = [3, n2, _ATINSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestInstallPythonStepInput$ = [3, n2, _ATIPSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallPythonStepOutput$ = [3, n2, _ATIPSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestInstallRStepInput$ = [3, n2, _ATIRSI,
    0,
    [_v, _i],
    [0, 0], 1
];
export var AutoTestInstallRStepOutput$ = [3, n2, _ATIRSO,
    0,
    [_i, _v],
    [0, 0], 2
];
export var AutoTestIoTestStepInput$ = [3, n2, _ATITSI,
    0,
    [_sc, _i, _n, _ch],
    [0, 0, 0, () => AutoTestTestStepsInput], 1
];
export var AutoTestIoTestStepOutput$ = [3, n2, _ATITSO,
    0,
    [_i, _n, _ch, _sc],
    [0, 0, () => AutoTestTestStepsOutput, 0], 4
];
export var AutoTestJavaCompileStepInput$ = [3, n2, _ATJCSI,
    0,
    [_p, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestJavaCompileStepOutput$ = [3, n2, _ATJCSO,
    0,
    [_i, _n, _d, _p],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestJunit5StepInput$ = [3, n2, _ATJSI,
    0,
    [_v, _tF, _i, _n, _d],
    [0, () => AutoTestJunit5TestFile$, 0, 0, () => AutoTestDescription$], 2
];
export var AutoTestJunit5StepOutput$ = [3, n2, _ATJSO,
    0,
    [_i, _n, _d, _v, _tF],
    [0, 0, () => AutoTestDescription$, 0, () => AutoTestJunit5TestFile$], 5
];
export var AutoTestJunit5TestFile$ = [3, n2, _ATJTF,
    0,
    [_n, _co],
    [0, 0], 2
];
export var AutoTestJupyterNotebookStepInput$ = [3, n2, _ATJNSI,
    0,
    [_k, _pKV, _rP, _i, _n, _ch, _tFe],
    [0, 0, 0, 0, 0, () => AutoTestTestStepsInput, () => AutoTestUploadedFileInput$], 3
];
export var AutoTestJupyterNotebookStepOutput$ = [3, n2, _ATJNSO,
    0,
    [_i, _n, _ch, _k, _pKV, _rP, _tFe],
    [0, 0, () => AutoTestTestStepsOutput, 0, 0, 0, () => AutoTestUploadedFileOutput$], 6
];
export var AutoTestMcqAnswersValue$ = [3, n2, _ATMAV,
    0,
    [_i, _an, _h],
    [0, 0, 0], 2
];
export var AutoTestMcqStepInput$ = [3, n2, _ATMSI,
    0,
    [_q, _ans, _i, _n, _d, _aO, _cAo],
    [0, () => AutoTestMcqAnswers, 0, 0, () => AutoTestDescription$, 0, 0], 2
];
export var AutoTestMcqStepOutput$ = [3, n2, _ATMSO,
    0,
    [_i, _n, _d, _q, _ans, _aO, _cAo],
    [0, 0, () => AutoTestDescription$, 0, () => AutoTestMcqAnswers, 0, 0], 5
];
export var AutoTestNegativeMatchStepInput$ = [3, n2, _ATNMSI,
    0,
    [_ru, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestNegativeMatchStepOutput$ = [3, n2, _ATNMSO,
    0,
    [_i, _n, _d, _ru],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestOutputStepInput$ = [3, n2, _ATOSI,
    0,
    [_tU, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestOutputStepOutput$ = [3, n2, _ATOSO,
    0,
    [_i, _n, _d, _tU],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestPartialUploadedFileOutput$ = [3, n2, _ATPUFO,
    0,
    [_i, _p, _si],
    [0, 0, 1], 3
];
export var AutoTestPositiveMatchStepInput$ = [3, n2, _ATPMSI,
    0,
    [_ru, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestPositiveMatchStepOutput$ = [3, n2, _ATPMSO,
    0,
    [_i, _n, _d, _ru],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestProgramStepInput$ = [3, n2, _ATPSI,
    0,
    [_sc, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestProgramStepOutput$ = [3, n2, _ATPSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestPromptEngineeringQuestionStepInput$ = [3, n2, _ATPEQSI,
    0,
    [_aF, _aL, _q, _sP, _i, _n, _ch],
    [0, 0, 0, 0, 0, 0, () => AutoTestTestStepsInput], 4
];
export var AutoTestPromptEngineeringQuestionStepOutput$ = [3, n2, _ATPEQSO,
    0,
    [_i, _n, _ch, _aF, _aL, _q, _sP],
    [0, 0, () => AutoTestTestStepsOutput, 0, 0, 0, 0], 7
];
export var AutoTestPublishedSnapshot$ = [3, n2, _ATPS,
    0,
    [_aI, _sI, _cA, _te],
    [0, 0, 5, () => AutoTestRedactedTestConfigurationOutput$], 4
];
export var AutoTestPytestStepInput$ = [3, n2, _ATPSIu,
    0,
    [_sc, _v, _i, _n, _d],
    [0, 0, 0, 0, () => AutoTestDescription$], 2
];
export var AutoTestPytestStepOutput$ = [3, n2, _ATPSOu,
    0,
    [_i, _n, _d, _sc, _v],
    [0, 0, () => AutoTestDescription$, 0, 0], 5
];
export var AutoTestQuizStepInput$ = [3, n2, _ATQSI,
    0,
    [_fN, _i, _ch, _rSQ, _vM],
    [0, 0, () => AutoTestTestStepsInput, 2, 0], 1
];
export var AutoTestQuizStepOutput$ = [3, n2, _ATQSO,
    0,
    [_i, _ch, _fN, _rSQ, _vM],
    [0, () => AutoTestTestStepsOutput, 0, 2, 0], 3
];
export var AutoTestRanSnapshotSource$ = [3, n2, _ATRSS,
    0,
    [_bP],
    [() => AutoTestSnapshotBuildProgram$], 1
];
export var AutoTestRedactedAllowInternetStepOutput$ = [3, n2, _ATRAISO,
    0,
    [_i, _ch],
    [0, () => AutoTestRedactedTestStepsOutput], 2
];
export var AutoTestRedactedCheckstyleStepOutput$ = [3, n2, _ATRCSO,
    0,
    [_i, _n, _d, _conf, _fi, _v, _de],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, () => AutoTestRedactedString$, () => AutoTestRedactedCheckstyleVersion$, () => AutoTestRedactedDeductions$], 7
];
export var AutoTestRedactedCodeStructureTestStepOutput$ = [3, n2, _ATRCSTSO,
    0,
    [_i, _n, _ch, _fil, _v],
    [0, 0, () => AutoTestRedactedTestStepsOutput, () => AutoTestRedactedString$, () => AutoTestRedactedCodeStructureTestVersion$], 5
];
export var AutoTestRedactedCodingQuestionStepOutput$ = [3, n2, _ATRCQSO,
    0,
    [_i, _n, _ch, _sFN, _q, _sC, _so],
    [0, 0, () => AutoTestRedactedTestStepsOutput, 0, 0, 0, () => AutoTestRedactedString$], 6
];
export var AutoTestRedactedConnectRubricStepOutput$ = [3, n2, _ATRCRSO,
    0,
    [_i, _ch, _rRI],
    [0, () => AutoTestRedactedTestStepsOutput, () => AutoTestRedactedInteger$], 2
];
export var AutoTestRedactedCustomTestStepOutput$ = [3, n2, _ATRCTSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedFlake8StepOutput$ = [3, n2, _ATRFSO,
    0,
    [_i, _n, _d, _conf, _fil, _v, _de],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, () => AutoTestRedactedString$, () => AutoTestRedactedFlake8Version$, () => AutoTestRedactedDeductions$], 7
];
export var AutoTestRedactedIoTestStepOutput$ = [3, n2, _ATRITSO,
    0,
    [_i, _n, _ch, _sc],
    [0, 0, () => AutoTestRedactedTestStepsOutput, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedJavaCompileStepOutput$ = [3, n2, _ATRJCSO,
    0,
    [_i, _n, _d, _p],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedJunit5StepOutput$ = [3, n2, _ATRJSO,
    0,
    [_i, _n, _d, _v, _tF],
    [0, 0, () => AutoTestDescription$, 0, () => AutoTestRedactedJunit5TestFile$], 5
];
export var AutoTestRedactedJupyterNotebookStepOutput$ = [3, n2, _ATRJNSO,
    0,
    [_i, _n, _ch, _k, _pKV, _rP, _tFe],
    [0, 0, () => AutoTestRedactedTestStepsOutput, 0, 0, 0, () => AutoTestPartialUploadedFileOutput$], 6
];
export var AutoTestRedactedMcqAnswersValue$ = [3, n2, _ATRMAV,
    0,
    [_i, _an, _h],
    [0, 0, () => AutoTestRedactedString$], 2
];
export var AutoTestRedactedMcqStepOutput$ = [3, n2, _ATRMSO,
    0,
    [_i, _n, _d, _q, _ans, _aO, _cAo],
    [0, 0, () => AutoTestDescription$, 0, () => AutoTestRedactedMcqAnswers, 0, () => AutoTestRedactedString$], 5
];
export var AutoTestRedactedNegativeMatchStepOutput$ = [3, n2, _ATRNMSO,
    0,
    [_i, _n, _d, _ru],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedOutputStepOutput$ = [3, n2, _ATROSO,
    0,
    [_i, _n, _d, _tU],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedPositiveMatchStepOutput$ = [3, n2, _ATRPMSO,
    0,
    [_i, _n, _d, _ru],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedProgramStepOutput$ = [3, n2, _ATRPSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedPromptEngineeringQuestionStepOutput$ = [3, n2, _ATRPEQSO,
    0,
    [_i, _n, _ch, _aF, _aL, _q, _sP],
    [0, 0, () => AutoTestRedactedTestStepsOutput, 0, 0, 0, 0], 7
];
export var AutoTestRedactedPytestStepOutput$ = [3, n2, _ATRPSOu,
    0,
    [_i, _n, _d, _sc, _v],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, 0], 5
];
export var AutoTestRedactedQuizStepOutput$ = [3, n2, _ATRQSO,
    0,
    [_i, _ch, _fN, _rSQ, _vM],
    [0, () => AutoTestRedactedTestStepsOutput, 0, 2, 0], 3
];
export var AutoTestRedactedRegexMatchStepOutput$ = [3, n2, _ATRRMSO,
    0,
    [_i, _n, _d, _iT, _oT, _cS, _wP],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, () => AutoTestRedactedString$, () => AutoTestRedactedCaseSensitivity$, () => AutoTestRedactedWhitespacesPolicy$], 7
];
export var AutoTestRedactedRunIfStepOutput$ = [3, n2, _ATRRISO,
    0,
    [_i, _ch, _cond],
    [0, () => AutoTestRedactedTestStepsOutput, () => AutoTestRedactedRunIfCondition$], 3
];
export var AutoTestRedactedRunInNotebookStepOutput$ = [3, n2, _ATRRINSO,
    0,
    [_i, _n, _d, _cC, _iMn, _tCI],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, () => AutoTestRedactedRunInNotebookInsertMethod$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedRunInStepOutput$ = [3, n2, _ATRRISOu,
    0,
    [_i, _ch, _en],
    [0, () => AutoTestRedactedTestStepsOutput, 0], 3
];
export var AutoTestRedactedSelectAllQuestionAnswersValue$ = [3, n2, _ATRSAQAV,
    0,
    [_i, _an, _iC, _hi],
    [0, 0, () => AutoTestRedactedBoolean$, () => AutoTestRedactedSelectAllQuestionAnswersValueHints$], 3
];
export var AutoTestRedactedSelectAllQuestionStepOutput$ = [3, n2, _ATRSAQSO,
    0,
    [_i, _n, _d, _q, _ans, _aO],
    [0, 0, () => AutoTestDescription$, 0, () => AutoTestRedactedSelectAllQuestionAnswers, 0], 5
];
export var AutoTestRedactedSimpleMatchStepOutput$ = [3, n2, _ATRSMSO,
    0,
    [_i, _n, _d, _iT, _oT, _cS, _wP],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, () => AutoTestRedactedString$, () => AutoTestRedactedCaseSensitivity$, () => AutoTestRedactedWhitespacesPolicy$], 7
];
export var AutoTestRedactedSimplePythonTestStepOutput$ = [3, n2, _ATRSPTSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$], 4
];
export var AutoTestRedactedSnapshotStepOutput$ = [3, n2, _ATRSSO,
    0,
    [_i, _ch],
    [0, () => AutoTestRedactedTestStepsOutput], 2
];
export var AutoTestRedactedSubstringMatchStepOutput$ = [3, n2, _ATRSMSOu,
    0,
    [_i, _n, _d, _iT, _oT, _cS, _wP],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedString$, () => AutoTestRedactedString$, () => AutoTestRedactedCaseSensitivity$, () => AutoTestRedactedWhitespacesPolicy$], 7
];
export var AutoTestRedactedTestConfigurationOutput$ = [3, n2, _ATRTCO,
    0,
    [_ste],
    [() => AutoTestRedactedTestStepsOutput], 1
];
export var AutoTestRedactedTestHideStepOutput$ = [3, n2, _ATRTHSO,
    0,
    [_i, _ch, _hTi, _pr, _wh],
    [0, () => AutoTestRedactedTestStepsOutput, 0, 0, 0], 5
];
export var AutoTestRedactedTestTimeoutEachStepOutput$ = [3, n2, _ATRTTESO,
    0,
    [_i, _ch, _ti],
    [0, () => AutoTestRedactedTestStepsOutput, () => AutoTestRedactedPositiveDuration$], 2
];
export var AutoTestRedactedTestUploadFilesStepOutput$ = [3, n2, _ATRTUFSO,
    0,
    [_i, _n, _d, _fi],
    [0, 0, () => AutoTestDescription$, () => AutoTestRedactedUploadedFilesOutput$], 4
];
export var AutoTestRedactedWeightStepOutput$ = [3, n2, _ATRWSO,
    0,
    [_i, _ch, _we],
    [0, () => AutoTestRedactedTestStepsOutput, () => AutoTestRedactedFraction$], 2
];
export var AutoTestRegexMatchStepInput$ = [3, n2, _ATRMSI,
    0,
    [_iT, _oT, _cS, _wP, _i, _n, _d],
    [0, 0, 0, 0, 0, 0, () => AutoTestDescription$], 4
];
export var AutoTestRegexMatchStepOutput$ = [3, n2, _ATRMSOu,
    0,
    [_i, _n, _d, _iT, _oT, _cS, _wP],
    [0, 0, () => AutoTestDescription$, 0, 0, 0, 0], 7
];
export var AutoTestRunIfCondition$ = [3, n2, _ATRIC,
    0,
    [_ty, _mP, _rRI],
    [0, 1, 1], 2
];
export var AutoTestRunIfStepInput$ = [3, n2, _ATRISI,
    0,
    [_cond, _i, _ch],
    [() => AutoTestRunIfCondition$, 0, () => AutoTestTestStepsInput], 1
];
export var AutoTestRunIfStepOutput$ = [3, n2, _ATRISO,
    0,
    [_i, _ch, _cond],
    [0, () => AutoTestTestStepsOutput, () => AutoTestRunIfCondition$], 3
];
export var AutoTestRunInNotebookStepInput$ = [3, n2, _ATRINSI,
    0,
    [_cC, _i, _n, _d, _iMn, _tCI],
    [0, 0, 0, () => AutoTestDescription$, 0, 0], 1
];
export var AutoTestRunInNotebookStepOutput$ = [3, n2, _ATRINSO,
    0,
    [_i, _n, _d, _cC, _iMn, _tCI],
    [0, 0, () => AutoTestDescription$, 0, 0, 0], 4
];
export var AutoTestRunInStepInput$ = [3, n2, _ATRISIu,
    0,
    [_en, _i, _ch],
    [0, 0, () => AutoTestTestStepsInput], 1
];
export var AutoTestRunInStepOutput$ = [3, n2, _ATRISOu,
    0,
    [_i, _ch, _en],
    [0, () => AutoTestTestStepsOutput, 0], 3
];
export var AutoTestScriptStepInput$ = [3, n2, _ATSSI,
    0,
    [_sc, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestScriptStepOutput$ = [3, n2, _ATSSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestSelectAllQuestionAnswersValue$ = [3, n2, _ATSAQAV,
    0,
    [_i, _an, _iC, _hi],
    [0, 0, 2, () => AutoTestSelectAllQuestionAnswersValueHints$], 3
];
export var AutoTestSelectAllQuestionAnswersValueHints$ = [3, n2, _ATSAQAVH,
    0,
    [_cor, _inc],
    [0, 0], 2
];
export var AutoTestSelectAllQuestionStepInput$ = [3, n2, _ATSAQSI,
    0,
    [_q, _ans, _i, _n, _d, _aO],
    [0, () => AutoTestSelectAllQuestionAnswers, 0, 0, () => AutoTestDescription$, 0], 2
];
export var AutoTestSelectAllQuestionStepOutput$ = [3, n2, _ATSAQSO,
    0,
    [_i, _n, _d, _q, _ans, _aO],
    [0, 0, () => AutoTestDescription$, 0, () => AutoTestSelectAllQuestionAnswers, 0], 5
];
export var AutoTestSetupConfigurationInput$ = [3, n2, _ATSCI,
    0,
    [_ste],
    [() => AutoTestSetupStepsInput], 1
];
export var AutoTestSetupConfigurationOutput$ = [3, n2, _ATSCO,
    0,
    [_met, _ste],
    [() => AutoTestSetupMetadata$, () => AutoTestSetupStepsOutput], 2
];
export var AutoTestSetupMetadata$ = [3, n2, _ATSM,
    0,
    [_bII],
    [0]
];
export var AutoTestSimpleMatchStepInput$ = [3, n2, _ATSMSI,
    0,
    [_iT, _oT, _cS, _wP, _i, _n, _d],
    [0, 0, 0, 0, 0, 0, () => AutoTestDescription$], 4
];
export var AutoTestSimpleMatchStepOutput$ = [3, n2, _ATSMSO,
    0,
    [_i, _n, _d, _iT, _oT, _cS, _wP],
    [0, 0, () => AutoTestDescription$, 0, 0, 0, 0], 7
];
export var AutoTestSimplePythonTestStepInput$ = [3, n2, _ATSPTSI,
    0,
    [_sc, _i, _n, _d],
    [0, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestSimplePythonTestStepOutput$ = [3, n2, _ATSPTSO,
    0,
    [_i, _n, _d, _sc],
    [0, 0, () => AutoTestDescription$, 0], 4
];
export var AutoTestSnapshot$ = [3, n2, _ATS,
    0,
    [_aI, _sI, _cA, _set, _te, _aIu, _sou],
    [0, 0, 5, () => AutoTestSetupConfigurationOutput$, () => AutoTestTestConfigurationOutput$, () => AutoTestAutoInstallConfigurationOutput$, () => AutoTestSnapshotSource$], 7
];
export var AutoTestSnapshotBuildProgram$ = [3, n2, _ATSBP,
    0,
    [_i, _sta],
    [0, 0], 2
];
export var AutoTestSnapshotStepInput$ = [3, n2, _ATSSIu,
    0,
    [_i, _ch],
    [0, () => AutoTestTestStepsInput]
];
export var AutoTestSnapshotStepOutput$ = [3, n2, _ATSSOu,
    0,
    [_i, _ch],
    [0, () => AutoTestTestStepsOutput], 2
];
export var AutoTestSnapshotSummary$ = [3, n2, _ATSS,
    0,
    [_aI, _sI, _cA, _sou],
    [0, 0, 5, () => AutoTestSnapshotSource$], 4
];
export var AutoTestSubstringMatchStepInput$ = [3, n2, _ATSMSIu,
    0,
    [_iT, _oT, _cS, _wP, _i, _n, _d],
    [0, 0, 0, 0, 0, 0, () => AutoTestDescription$], 4
];
export var AutoTestSubstringMatchStepOutput$ = [3, n2, _ATSMSOu,
    0,
    [_i, _n, _d, _iT, _oT, _cS, _wP],
    [0, 0, () => AutoTestDescription$, 0, 0, 0, 0], 7
];
export var AutoTestTestConfigurationInput$ = [3, n2, _ATTCI,
    0,
    [_ste],
    [() => AutoTestTestStepsInput], 1
];
export var AutoTestTestConfigurationOutput$ = [3, n2, _ATTCO,
    0,
    [_ste],
    [() => AutoTestTestStepsOutput], 1
];
export var AutoTestTestHideStepInput$ = [3, n2, _ATTHSI,
    0,
    [_hTi, _pr, _wh, _i, _ch],
    [0, 0, 0, 0, () => AutoTestTestStepsInput], 3
];
export var AutoTestTestHideStepOutput$ = [3, n2, _ATTHSO,
    0,
    [_i, _ch, _hTi, _pr, _wh],
    [0, () => AutoTestTestStepsOutput, 0, 0, 0], 5
];
export var AutoTestTestTimeoutEachStepInput$ = [3, n2, _ATTTESI,
    0,
    [_i, _ch, _ti],
    [0, () => AutoTestTestStepsInput, 1]
];
export var AutoTestTestTimeoutEachStepOutput$ = [3, n2, _ATTTESO,
    0,
    [_i, _ch, _ti],
    [0, () => AutoTestTestStepsOutput, 1], 2
];
export var AutoTestTestUploadFilesStepInput$ = [3, n2, _ATTUFSI,
    0,
    [_fi, _i, _n, _d],
    [() => AutoTestUploadedFilesInput, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestTestUploadFilesStepOutput$ = [3, n2, _ATTUFSO,
    0,
    [_i, _n, _d, _fi],
    [0, 0, () => AutoTestDescription$, () => AutoTestUploadedFilesOutput], 4
];
export var AutoTestUploadedFileInput$ = [3, n2, _ATUFI,
    0,
    [_i, _p, _cont],
    [0, 0, 21]
];
export var AutoTestUploadedFileOutput$ = [3, n2, _ATUFO,
    0,
    [_i, _p, _si, _u],
    [0, 0, 1, 0], 4
];
export var AutoTestUploadFilesStepInput$ = [3, n2, _ATUFSI,
    0,
    [_fi, _i, _n, _d],
    [() => AutoTestUploadedFilesInput, 0, 0, () => AutoTestDescription$], 1
];
export var AutoTestUploadFilesStepOutput$ = [3, n2, _ATUFSO,
    0,
    [_i, _n, _d, _fi],
    [0, 0, () => AutoTestDescription$, () => AutoTestUploadedFilesOutput], 4
];
export var AutoTestWeightStepInput$ = [3, n2, _ATWSI,
    0,
    [_i, _ch, _we],
    [0, () => AutoTestTestStepsInput, () => Fraction$]
];
export var AutoTestWeightStepOutput$ = [3, n2, _ATWSO,
    0,
    [_i, _ch, _we],
    [0, () => AutoTestTestStepsOutput, () => Fraction$], 2
];
export var CompleteImportAutoTestConfigurationRequest$ = [3, n2, _CIATCR,
    0,
    [_aI, _dAI, _rC],
    [[0, 1], 0, () => CompleteImportAutoTestConfigurationRubricConfiguration$], 3
];
export var CompleteImportAutoTestConfigurationResponse$ = [3, n2, _CIATCRo,
    0,
    [],
    []
];
export var CompleteImportAutoTestConfigurationRubricConfiguration$ = [3, n2, _CIATCRC,
    0,
    [_ma, _lI],
    [() => RubricMappingList, 0], 2
];
export var CopyAutoTestConfigurationRequest$ = [3, n2, _CATCR,
    0,
    [_aI, _dAI, _oR],
    [[0, 1], 0, () => AutoTestOverwriteRubric$], 3
];
export var CopyAutoTestConfigurationResponse$ = [3, n2, _CATCRo,
    0,
    [],
    []
];
export var CreateAutoTestSnapshotRequest$ = [3, n2, _CATSR,
    0,
    [_aI],
    [[0, 1]], 1
];
export var CreateAutoTestSnapshotResponse$ = [3, n2, _CATSRr,
    0,
    [_sn],
    [[() => AutoTestSnapshotSummary$, 16]], 1
];
export var DeleteAutoTestConfigurationRequest$ = [3, n2, _DATCR,
    0,
    [_aI],
    [[0, 1]], 1
];
export var DeleteAutoTestConfigurationResponse$ = [3, n2, _DATCRe,
    0,
    [],
    []
];
export var GetAutoTestConfigurationRequest$ = [3, n2, _GATCR,
    0,
    [_aI],
    [[0, 1]], 1
];
export var GetAutoTestConfigurationResponse$ = [3, n2, _GATCRe,
    0,
    [_confi],
    [[() => AutoTestConfiguration$, 16]], 1
];
export var GetAutoTestPublishedSnapshotRequest$ = [3, n2, _GATPSR,
    0,
    [_aI],
    [[0, 1]], 1
];
export var GetAutoTestPublishedSnapshotResponse$ = [3, n2, _GATPSRe,
    0,
    [_sn],
    [[() => AutoTestPublishedSnapshot$, 16]], 1
];
export var GetAutoTestRubricResultsRequest$ = [3, n2, _GATRRR,
    0,
    [_aI, _rRI, _sIu],
    [[0, 1], [1, 1], [64 | 0, { [_hH]: _XSI }]], 3
];
export var GetAutoTestRubricResultsResponse$ = [3, n2, _GATRRRe,
    0,
    [_rR],
    [128 | 0], 1
];
export var GetAutoTestSnapshotRequest$ = [3, n2, _GATSR,
    0,
    [_aI, _sI],
    [[0, 1], [0, 1]], 2
];
export var GetAutoTestSnapshotResponse$ = [3, n2, _GATSRe,
    0,
    [_sn],
    [[() => AutoTestSnapshot$, 16]], 1
];
export var ListAutoTestSnapshotsRequest$ = [3, n2, _LATSR,
    0,
    [_aI, _nT, _pS],
    [[0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 1
];
export var ListAutoTestSnapshotsResponse$ = [3, n2, _LATSRi,
    0,
    [_sna, _nT],
    [() => AutoTestSnapshotSummaries, [0, { [_hH]: _XNT }]], 1
];
export var PutAutoTestConfigurationRequest$ = [3, n2, _PATCR,
    0,
    [_aI],
    [[0, 1]], 1
];
export var PutAutoTestConfigurationResponse$ = [3, n2, _PATCRu,
    0,
    [_confi],
    [[() => AutoTestConfiguration$, 16]], 1
];
export var RubricMapping$ = [3, n2, _RM,
    0,
    [_sRRI, _dRRI],
    [1, 1], 2
];
export var UpdateAutoTestConfigurationRequest$ = [3, n2, _UATCR,
    0,
    [_aI, _uS, _uT, _pSu],
    [[0, 1], () => AutoTestSetupConfigurationInput$, () => AutoTestTestConfigurationInput$, () => AutoTestPublishedSnapshotId$], 1
];
export var UpdateAutoTestConfigurationResponse$ = [3, n2, _UATCRp,
    0,
    [_confi],
    [[() => AutoTestConfiguration$, 16]], 1
];
export var Fraction$ = [3, n3, _F,
    0,
    [_nu, _den],
    [1, 1], 2
];
export var Group$ = [3, n3, _G,
    0,
    [_i, _mem, _n, _gSI, _cA],
    [0, () => GroupMembers, 0, 0, 5], 5
];
export var GroupUser$ = [3, n3, _GU,
    0,
    [_i, _us, _tI, _gr],
    [0, 0, 0, () => Group$], 4
];
export var NormalUser$ = [3, n3, _NU,
    0,
    [_i, _us, _tI, _iTS, _n],
    [0, 0, 0, 2, 0], 4
];
export var CreateEditorSessionRequest$ = [3, n4, _CESR,
    0,
    [_aI, _n, _ow, _sou],
    [0, 0, 0, () => EditorSessionSource$], 4
];
export var CreateEditorSessionResponse$ = [3, n4, _CESRr,
    0,
    [_eS],
    [[() => EditorSession$, 16]], 1
];
export var EditorDocument$ = [3, n4, _ED,
    0,
    [_dI, _eSI, _p, _k],
    [0, 0, 0, () => JupyterKernel$], 4
];
export var EditorSession$ = [3, n4, _ES,
    0,
    [_eSI, _ow, _aI, _n, _cA, _uA, _fTI],
    [0, 0, 0, 0, 5, 5, 0], 7
];
export var EditorSessionSubmissionSource$ = [3, n4, _ESSS,
    0,
    [_sIub],
    [0], 1
];
export var EditorSessionTemplateSource$ = [3, n4, _ESTS,
    0,
    [],
    []
];
export var ExecuteEditorDocumentJupyterCellRequest$ = [3, n4, _EEDJCR,
    0,
    [_dI, _cIe, _cod],
    [[0, 1], [0, 1], [0, 16]], 3
];
export var ExecuteEditorDocumentJupyterCellResponse$ = [3, n4, _EEDJCRx,
    0,
    [],
    []
];
export var GetEditorDocumentRequest$ = [3, n4, _GEDR,
    0,
    [_dI],
    [[0, 1]], 1
];
export var GetEditorDocumentResponse$ = [3, n4, _GEDRe,
    0,
    [_do],
    [[() => EditorDocument$, 16]], 1
];
export var GetEditorFileDownloadLinkRequest$ = [3, n4, _GEFDLR,
    0,
    [_eSI, _p],
    [[0, 1], [0, { [_hQ]: _p }]], 2
];
export var GetEditorFileDownloadLinkResponse$ = [3, n4, _GEFDLRe,
    0,
    [_u, _file, _cT],
    [0, 0, 0], 3
];
export var GetEditorSessionRequest$ = [3, n4, _GESR,
    0,
    [_eSI],
    [[0, 1]], 1
];
export var GetEditorSessionResponse$ = [3, n4, _GESRe,
    0,
    [_eS],
    [[() => EditorSession$, 16]], 1
];
export var HandInEditorSessionRequest$ = [3, n4, _HIESR,
    0,
    [_eSI, _iNIQ],
    [[0, 1], 2], 2
];
export var HandInEditorSessionResponse$ = [3, n4, _HIESRa,
    0,
    [_eSd],
    [() => SubmissionReference$], 1
];
export var InputEditorDirectoryType$ = [3, n4, _IEDT,
    0,
    [],
    []
];
export var InputRegularFileType$ = [3, n4, _IRFT,
    0,
    [_co],
    [0]
];
export var InterruptEditorDocumentJupyterKernelRequest$ = [3, n4, _IEDJKR,
    0,
    [_dI],
    [[0, 1]], 1
];
export var InterruptEditorDocumentJupyterKernelResponse$ = [3, n4, _IEDJKRn,
    0,
    [],
    []
];
export var JupyterDisplayDataOutputEvent$ = [3, n4, _JDDOE,
    0,
    [_mD, _kI, _dIi],
    [() => JupyterMimeOutputDataEvent, 0, 0], 1
];
export var JupyterErrorOutputEvent$ = [3, n4, _JEOE,
    0,
    [_n, _va, _tr, _kI, _eC],
    [0, 0, 64 | 0, 0, 1], 3
];
export var JupyterExecuteInterruptedOutputEvent$ = [3, n4, _JEIOE,
    0,
    [],
    []
];
export var JupyterExecuteReqeustedOutputEvent$ = [3, n4, _JEROE,
    0,
    [_eC],
    [1]
];
export var JupyterExecuteResultOutputEvent$ = [3, n4, _JEROEu,
    0,
    [_mD, _kI, _eC],
    [() => JupyterMimeOutputDataEvent, 0, 1], 1
];
export var JupyterExecuteStartOutputEvent$ = [3, n4, _JESOE,
    0,
    [_kI, _eC],
    [0, 1]
];
export var JupyterKernel$ = [3, n4, _JK,
    0,
    [_st],
    [() => JupyterKernelStatus$], 1
];
export var JupyterKernelAlive$ = [3, n4, _JKA,
    0,
    [_kI],
    [0], 1
];
export var JupyterKernelDead$ = [3, n4, _JKD,
    0,
    [],
    []
];
export var JupyterKernelStarting$ = [3, n4, _JKS,
    0,
    [],
    []
];
export var JupyterMimeOutputDataEventValueLink$ = [3, n4, _JMODEVL,
    0,
    [_u],
    [0], 1
];
export var JupyterOutput$ = [3, n4, _JO,
    0,
    [_jOI, _ev],
    [0, () => JupyterOutputEvent$], 2
];
export var JupyterStreamOutputEvent$ = [3, n4, _JSOE,
    0,
    [_n, _va, _kI],
    [0, () => JupyterStreamOutputEventValue$, 0], 2
];
export var JupyterStreamOutputEventValueLink$ = [3, n4, _JSOEVL,
    0,
    [_u],
    [0], 1
];
export var ListEditorDocumentJupyterCellOutputsRequest$ = [3, n4, _LEDJCOR,
    0,
    [_dI, _cIe, _nT, _pS],
    [[0, 1], [0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 2
];
export var ListEditorDocumentJupyterCellOutputsResponse$ = [3, n4, _LEDJCORi,
    0,
    [_ou, _nT],
    [() => JupyterOutputs, [0, { [_hH]: _XNT }]], 1
];
export var ListEditorDocumentsRequest$ = [3, n4, _LEDR,
    0,
    [_eSI, _nT, _pS],
    [[0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 1
];
export var ListEditorDocumentsResponse$ = [3, n4, _LEDRi,
    0,
    [_doc, _nT],
    [() => EditorDocuments, [0, { [_hH]: _XNT }]], 1
];
export var ListEditorSessionsRequest$ = [3, n4, _LESR,
    0,
    [_aI, _uI, _nT, _pS],
    [[0, { [_hQ]: _aI }], [0, 1], [0, { [_hH]: _XNT }], [1, { [_hH]: _XPS }]], 2
];
export var ListEditorSessionsResponse$ = [3, n4, _LESRi,
    0,
    [_eSdi, _nT],
    [() => EditorSessions, [0, { [_hH]: _XNT }]], 1
];
export var OutputEditorDirectoryType$ = [3, n4, _OEDT,
    0,
    [_ch],
    [() => EditorFileList], 1
];
export var OutputEditorFile$ = [3, n4, _OEF,
    0,
    [_eSI, _p, _aI, _fT],
    [0, 0, 0, () => EditorFileType$], 4
];
export var OutputJupyterNotebookFileType$ = [3, n4, _OJNFT,
    0,
    [_dI],
    [0], 1
];
export var OutputRegularBinaryFileType$ = [3, n4, _ORBFT,
    0,
    [],
    []
];
export var OutputRegularQuizFileType$ = [3, n4, _ORQFT,
    0,
    [_dI],
    [0], 1
];
export var OutputRegularTextFileType$ = [3, n4, _ORTFT,
    0,
    [_dI],
    [0], 1
];
export var PutEditorFileRequest$ = [3, n4, _PEFR,
    0,
    [_eSI, _p, _fT],
    [[0, 1], 0, () => InputFileType$], 3
];
export var PutEditorFileResponse$ = [3, n4, _PEFRu,
    0,
    [_fil],
    [[() => OutputEditorFile$, 16]], 1
];
export var SubmissionReference$ = [3, n4, _SR,
    0,
    [_sIub, _aI],
    [0, 0], 2
];
export var FoundUnknownEnumType$ = [3, n0, _FUET,
    0,
    [_ty, _va],
    [0, 15], 2
];
export var IgnoreNonInteractedQuestions$ = [3, n0, _INIQ,
    0,
    [],
    []
];
export var InexplicitRubricOverwriteReason$ = [3, n0, _IROR,
    0,
    [],
    []
];
export var InvalidParamErrorReason$ = [3, n0, _IPER,
    0,
    [_n, _va, _e],
    [0, 15, 0], 3
];
export var InvalidStateErrorReason$ = [3, n0, _ISER,
    0,
    [],
    []
];
export var TierRestrictedErrorReason$ = [3, n0, _TRER,
    0,
    [_rA],
    [64 | 0]
];
export var UnknownEnumTypeErrorReason$ = [3, n0, _UETER,
    0,
    [_fo],
    [() => FoundUnknownEnumType$], 1
];
export var ValidationErrorField$ = [3, n0, _VEF,
    0,
    [_p, _m],
    [0, 0], 2
];
export var WrongItemCountErrorReason$ = [3, n0, _WICER,
    0,
    [_wha, _fo, _mA, _mAi],
    [0, 64 | 15, 1, 1], 2
];
export var GetPearsonContextTemplateQuestionRequest$ = [3, n5, _GPCTQR,
    0,
    [_tI, _tIe, _cIo, _qI],
    [[0, 1], [0, 1], [0, 1], [0, 1]], 4
];
export var GetPearsonContextTemplateQuestionResponse$ = [3, n5, _GPCTQRe,
    0,
    [_q],
    [[() => PearsonContextTemplateQuestion$, 16]], 1
];
export var GetPearsonContextTemplateRequest$ = [3, n5, _GPCTR,
    0,
    [_tI, _tIe, _cIo],
    [[0, 1], [0, 1], [0, 1]], 3
];
export var GetPearsonContextTemplateResponse$ = [3, n5, _GPCTRe,
    0,
    [_cTo],
    [[() => PearsonContextTemplate$, 16]], 1
];
export var InstantiatePearsonTemplateRequest$ = [3, n5, _IPTR,
    0,
    [_tI, _tIe, _dAI, _qM],
    [[0, 1], [0, 1], 1, 128 | 1], 4
];
export var InstantiatePearsonTemplateResponse$ = [3, n5, _IPTRn,
    0,
    [_rRL],
    [0], 1
];
export var PearsonCodingQuestionData$ = [3, n5, _PCQD,
    0,
    [_file, _tem, _d, _cAo, _vCA, _aTS],
    [0, 0, 0, 0, 2, 15], 6
];
export var PearsonContextTemplate$ = [3, n5, _PCT,
    0,
    [_tI, _tIe, _cIo, _bI, _n, _qu, _nOA],
    [0, 0, 0, 0, 0, () => PearsonContextTemplateQuestionSummaries, () => NumberOfAttempts$], 7
];
export var PearsonContextTemplateQuestion$ = [3, n5, _PCTQ,
    0,
    [_n, _ena, _da, _qI],
    [0, 2, () => PearsonQuestionData$, 0], 4
];
export var PearsonContextTemplateQuestionReference$ = [3, n5, _PCTQR,
    0,
    [_tI, _tIe, _cIo, _qI],
    [0, 0, 0, 0], 4
];
export var PearsonContextTemplateQuestionSummary$ = [3, n5, _PCTQS,
    0,
    [_n, _ena, _qI],
    [0, 2, 0], 3
];
export var PearsonMultipleChoiceQuestionAnswer$ = [3, n5, _PMCQA,
    0,
    [_an, _iC, _h],
    [0, 2, 0], 1
];
export var PearsonMultipleChoiceQuestionData$ = [3, n5, _PMCQD,
    0,
    [_q, _ans, _aO],
    [0, () => PearsonMultipleChoiceQuestionAnswers, 0], 2
];
export var PearsonSelectAllQuestionAnswer$ = [3, n5, _PSAQA,
    0,
    [_an, _iC, _hi],
    [0, 2, () => PearsonSelectAllQuestionAnswerHints$], 1
];
export var PearsonSelectAllQuestionAnswerHints$ = [3, n5, _PSAQAH,
    0,
    [_cor, _inc],
    [0, 0]
];
export var PearsonSelectAllQuestionData$ = [3, n5, _PSAQD,
    0,
    [_q, _ans, _aO],
    [0, () => PearsonSelectAllQuestionAnswers, 0], 2
];
export var PutPearsonBookRequest$ = [3, n5, _PPBR,
    0,
    [_tI, _bI, _au, _y, _la, _ta, _bAI],
    [[0, 1], [0, 1], 0, 1, 0, 128 | 0, 1], 7
];
export var PutPearsonBookResponse$ = [3, n5, _PPBRu,
    0,
    [],
    []
];
export var PutPearsonCodingQuestionSource$ = [3, n5, _PPCQS,
    0,
    [_aI, _vCA],
    [1, 2], 2
];
export var PutPearsonContextTemplateRequest$ = [3, n5, _PPCTR,
    0,
    [_tI, _tIe, _cIo],
    [[0, 1], [0, 1], [0, 1]], 3
];
export var PutPearsonContextTemplateResponse$ = [3, n5, _PPCTRu,
    0,
    [],
    []
];
export var PutPearsonQuestionRequest$ = [3, n5, _PPQR,
    0,
    [_tI, _tIe, _qI, _n, _sou],
    [[0, 1], [0, 1], [0, 1], 0, () => PutPearsonQuestionSource$], 5
];
export var PutPearsonQuestionResponse$ = [3, n5, _PPQRu,
    0,
    [_qI],
    [0], 1
];
export var PutPearsonTemplateRequest$ = [3, n5, _PPTR,
    0,
    [_tI, _tIe, _n, _bI, _vM, _rSQ],
    [[0, 1], [0, 1], 0, 0, 0, 2], 4
];
export var PutPearsonTemplateResponse$ = [3, n5, _PPTRu,
    0,
    [],
    []
];
export var UpdatePearsonContextTemplateQuestionRequest$ = [3, n5, _UPCTQR,
    0,
    [_tI, _tIe, _cIo, _qI, _ena],
    [[0, 1], [0, 1], [0, 1], [0, 1], 2], 4
];
export var UpdatePearsonContextTemplateQuestionResponse$ = [3, n5, _UPCTQRp,
    0,
    [_q],
    [[() => PearsonContextTemplateQuestion$, 16]], 1
];
export var UpdatePearsonContextTemplateRequest$ = [3, n5, _UPCTR,
    0,
    [_tI, _tIe, _cIo, _nOA],
    [[0, 1], [0, 1], [0, 1], () => NumberOfAttempts$], 3
];
export var UpdatePearsonContextTemplateResponse$ = [3, n5, _UPCTRp,
    0,
    [_cTo],
    [[() => PearsonContextTemplate$, 16]], 1
];
export var CreateSafeProgramRequest$ = [3, n6, _CSPR,
    0,
    [_sou],
    [() => SafeProgramSource$], 1
];
export var CreateSafeProgramResponse$ = [3, n6, _CSPRr,
    0,
    [_sPa],
    [[() => SafeProgram$, 16]], 1
];
export var SafeProgram$ = [3, n6, _SP,
    0,
    [_pI],
    [0], 1
];
export var SafeProgramPearsonQuestionSource$ = [3, n6, _SPPQS,
    0,
    [_q, _cod],
    [() => PearsonContextTemplateQuestionReference$, 0], 2
];
export var SafeProgramSingleQuizQuestionSource$ = [3, n6, _SPSQQS,
    0,
    [_qI, _eSI],
    [0, 0], 2
];
export var SafeProgramSubmissionSource$ = [3, n6, _SPSS,
    0,
    [_sIub],
    [0], 1
];
var __Unit = "unit";
var AssistantConversations = [1, n1, _ACs,
    0, () => AssistantConversation$
];
var AssistantFeatures = 64 | 0;
var AssistantMessageContentBlocks = [1, n1, _AMCB,
    0, () => AssistantMessageContentBlock$
];
var AssistantMessages = [1, n1, _AMs,
    0, () => AssistantMessage$
];
var Assistants = [1, n1, _As,
    0, () => Assistant$
];
var AutoTestAutoInstallStepsOutput = [1, n2, _ATAISOu,
    0, () => AutoTestAutoInstallStepOutput$
];
var AutoTestMcqAnswers = [1, n2, _ATMA,
    0, () => AutoTestMcqAnswersValue$
];
var AutoTestPartialUploadedFilesOutput = [1, n2, _ATPUFOu,
    0, () => AutoTestPartialUploadedFileOutput$
];
var AutoTestRedactedMcqAnswers = [1, n2, _ATRMA,
    0, () => AutoTestRedactedMcqAnswersValue$
];
var AutoTestRedactedSelectAllQuestionAnswers = [1, n2, _ATRSAQA,
    0, () => AutoTestRedactedSelectAllQuestionAnswersValue$
];
var AutoTestRedactedTestStepsOutput = [1, n2, _ATRTSO,
    0, () => AutoTestRedactedTestStepOutput$
];
var AutoTestSelectAllQuestionAnswers = [1, n2, _ATSAQA,
    0, () => AutoTestSelectAllQuestionAnswersValue$
];
var AutoTestSetupStepsInput = [1, n2, _ATSSIut,
    0, () => AutoTestSetupStepInput$
];
var AutoTestSetupStepsOutput = [1, n2, _ATSSOut,
    0, () => AutoTestSetupStepOutput$
];
var AutoTestSnapshotSummaries = [1, n2, _ATSSu,
    0, () => AutoTestSnapshotSummary$
];
var AutoTestTestStepsInput = [1, n2, _ATTSI,
    0, () => AutoTestTestStepInput$
];
var AutoTestTestStepsOutput = [1, n2, _ATTSO,
    0, () => AutoTestTestStepOutput$
];
var AutoTestUploadedFilesInput = [1, n2, _ATUFIu,
    0, () => AutoTestUploadedFileInput$
];
var AutoTestUploadedFilesOutput = [1, n2, _ATUFOu,
    0, () => AutoTestUploadedFileOutput$
];
var RubricMappingList = [1, n2, _RML,
    0, () => RubricMapping$
];
var SubmissionIds = 64 | 0;
var GroupMembers = [1, n3, _GM,
    0, () => NormalUser$
];
var EditorDocuments = [1, n4, _EDd,
    0, () => EditorDocument$
];
var EditorFileList = [1, n4, _EFL,
    0, () => EditorFileType$
];
var EditorSessions = [1, n4, _ESd,
    0, () => EditorSession$
];
var JupyterErrorTracebackOutput = 64 | 0;
var JupyterOutputs = [1, n4, _JOu,
    0, () => JupyterOutput$
];
var TierRestrictedAddons = 64 | 0;
var ValidationErrorFieldList = [1, n0, _VEFL,
    0, () => ValidationErrorField$
];
var PearsonContextTemplateQuestionSummaries = [1, n5, _PCTQSe,
    0, () => PearsonContextTemplateQuestionSummary$
];
var PearsonMultipleChoiceQuestionAnswers = [1, n5, _PMCQAe,
    0, () => PearsonMultipleChoiceQuestionAnswer$
];
var PearsonSelectAllQuestionAnswers = [1, n5, _PSAQAe,
    0, () => PearsonSelectAllQuestionAnswer$
];
var DocumentList = 64 | 15;
var AutoTestRubricResults = 128 | 0;
var JupyterMimeOutputDataEvent = [2, n4, _JMODE,
    0, 0, () => JupyterMimeOutputDataEventValue$
];
var InstantiatePearsonQuestionMapping = 128 | 1;
var PearsonBookTags = 128 | 0;
export var AssistantData$ = [4, n1, _AD,
    0,
    [_assi],
    [() => AssignmentAssistantData$]
];
export var AssistantMessageAssistantContent$ = [4, n1, _AMAC,
    0,
    [_tex],
    [0]
];
export var AssistantMessageContentBlock$ = [4, n1, _AMCBs,
    0,
    [_th, _tUo],
    [() => AssistantMessageThinkingBlock$, () => AssistantMessageToolUseBlock$]
];
export var AssistantMessageData$ = [4, n1, _AMD,
    0,
    [_use, _as],
    [() => AssistantMessageUserData$, () => AssistantMessageAssistantData$]
];
export var AssistantMessageStopReason$ = [4, n1, _AMSR,
    0,
    [_eT, _mT, _gRu],
    [() => __Unit, () => AssistantMessageStopMaxTokens$, () => AssistantMessageStopGuardrails$]
];
export var AssistantMessageUserContent$ = [4, n1, _AMUC,
    0,
    [_tex],
    [0]
];
export var AssistantStatus$ = [4, n1, _AS,
    0,
    [_ena, _di],
    [() => __Unit, () => __Unit]
];
export var AutoTestAutoInstallStepOutput$ = [4, n2, _ATAISOut,
    0,
    [_aIF, _aIP, _aICST, _aISPT, _aIJN],
    [() => AutoInstallFlake8StepOutput$, () => AutoInstallPytestStepOutput$, () => AutoInstallCodeStructureTestStepOutput$, () => AutoInstallSimplePythonTestStepOutput$, () => AutoInstallJupyterNotebookStepOutput$]
];
export var AutoTestOverwriteRubric$ = [4, n2, _ATOR,
    0,
    [_dO, _dNO],
    [() => AutoTestDoOverwriteCase$, () => AutoTestDoNotOverwriteCase$]
];
export var AutoTestPublishedSnapshotId$ = [4, n2, _ATPSIut,
    0,
    [_un, _pu],
    [() => __Unit, 0]
];
export var AutoTestRedactedBoolean$ = [4, n2, _ATRB,
    0,
    [_red, _unr],
    [() => __Unit, 2]
];
export var AutoTestRedactedCaseSensitivity$ = [4, n2, _ATRCS,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestRedactedCheckstyleVersion$ = [4, n2, _ATRCV,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestRedactedCodeStructureTestVersion$ = [4, n2, _ATRCSTV,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestRedactedDeductions$ = [4, n2, _ATRD,
    0,
    [_red, _unr],
    [() => __Unit, () => AutoTestDeductions$]
];
export var AutoTestRedactedFlake8Version$ = [4, n2, _ATRFV,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestRedactedFraction$ = [4, n2, _ATRF,
    0,
    [_red, _unr],
    [() => __Unit, () => Fraction$]
];
export var AutoTestRedactedInteger$ = [4, n2, _ATRI,
    0,
    [_red, _unr],
    [() => __Unit, 1]
];
export var AutoTestRedactedJunit5TestFile$ = [4, n2, _ATRJTF,
    0,
    [_red, _unr],
    [() => __Unit, () => AutoTestJunit5TestFile$]
];
export var AutoTestRedactedPositiveDuration$ = [4, n2, _ATRPD,
    0,
    [_red, _unr],
    [() => __Unit, 1]
];
export var AutoTestRedactedRunIfCondition$ = [4, n2, _ATRRIC,
    0,
    [_red, _unr],
    [() => __Unit, () => AutoTestRunIfCondition$]
];
export var AutoTestRedactedRunInNotebookInsertMethod$ = [4, n2, _ATRRINIM,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestRedactedSelectAllQuestionAnswersValueHints$ = [4, n2, _ATRSAQAVH,
    0,
    [_red, _unr],
    [() => __Unit, () => AutoTestSelectAllQuestionAnswersValueHints$]
];
export var AutoTestRedactedString$ = [4, n2, _ATRS,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestRedactedTestStepOutput$ = [4, n2, _ATRTSOu,
    0,
    [_tH, _rIu, _rIun, _aIl, _cR, _we, _che, _jC, _j, _cTu, _tTE, _fl, _py, _sPT, _jN, _rIN, _out, _tUF, _sn, _iTo, _sM, _rM, _sMu, _cST, _nM, _pM, _qui, _cQ, _pEQ, _mc, _sAQ, _pro],
    [() => AutoTestRedactedTestHideStepOutput$, () => AutoTestRedactedRunInStepOutput$, () => AutoTestRedactedRunIfStepOutput$, () => AutoTestRedactedAllowInternetStepOutput$, () => AutoTestRedactedConnectRubricStepOutput$, () => AutoTestRedactedWeightStepOutput$, () => AutoTestRedactedCheckstyleStepOutput$, () => AutoTestRedactedJavaCompileStepOutput$, () => AutoTestRedactedJunit5StepOutput$, () => AutoTestRedactedCustomTestStepOutput$, () => AutoTestRedactedTestTimeoutEachStepOutput$, () => AutoTestRedactedFlake8StepOutput$, () => AutoTestRedactedPytestStepOutput$, () => AutoTestRedactedSimplePythonTestStepOutput$, () => AutoTestRedactedJupyterNotebookStepOutput$, () => AutoTestRedactedRunInNotebookStepOutput$, () => AutoTestRedactedOutputStepOutput$, () => AutoTestRedactedTestUploadFilesStepOutput$, () => AutoTestRedactedSnapshotStepOutput$, () => AutoTestRedactedIoTestStepOutput$, () => AutoTestRedactedSimpleMatchStepOutput$, () => AutoTestRedactedRegexMatchStepOutput$, () => AutoTestRedactedSubstringMatchStepOutput$, () => AutoTestRedactedCodeStructureTestStepOutput$, () => AutoTestRedactedNegativeMatchStepOutput$, () => AutoTestRedactedPositiveMatchStepOutput$, () => AutoTestRedactedQuizStepOutput$, () => AutoTestRedactedCodingQuestionStepOutput$, () => AutoTestRedactedPromptEngineeringQuestionStepOutput$, () => AutoTestRedactedMcqStepOutput$, () => AutoTestRedactedSelectAllQuestionStepOutput$, () => AutoTestRedactedProgramStepOutput$]
];
export var AutoTestRedactedUploadedFilesOutput$ = [4, n2, _ATRUFO,
    0,
    [_red, _unr],
    [() => __Unit, () => AutoTestPartialUploadedFilesOutput]
];
export var AutoTestRedactedWhitespacesPolicy$ = [4, n2, _ATRWP,
    0,
    [_red, _unr],
    [() => __Unit, 0]
];
export var AutoTestSetupStepInput$ = [4, n2, _ATSSIuto,
    0,
    [_iD, _iJ, _iP, _iN, _uF, _iCn, _iG, _iR, _sc],
    [() => AutoTestInstallDotnetStepInput$, () => AutoTestInstallJavaStepInput$, () => AutoTestInstallPythonStepInput$, () => AutoTestInstallNodeStepInput$, () => AutoTestUploadFilesStepInput$, () => AutoTestInstallClangStepInput$, () => AutoTestInstallGccStepInput$, () => AutoTestInstallRStepInput$, () => AutoTestScriptStepInput$]
];
export var AutoTestSetupStepOutput$ = [4, n2, _ATSSOuto,
    0,
    [_iD, _iJ, _iP, _iN, _uF, _iCn, _iG, _iR, _sc],
    [() => AutoTestInstallDotnetStepOutput$, () => AutoTestInstallJavaStepOutput$, () => AutoTestInstallPythonStepOutput$, () => AutoTestInstallNodeStepOutput$, () => AutoTestUploadFilesStepOutput$, () => AutoTestInstallClangStepOutput$, () => AutoTestInstallGccStepOutput$, () => AutoTestInstallRStepOutput$, () => AutoTestScriptStepOutput$]
];
export var AutoTestSnapshotSource$ = [4, n2, _ATSSut,
    0,
    [_ra, _cop],
    [() => AutoTestRanSnapshotSource$, () => AutoTestCopiedSnapshotSource$]
];
export var AutoTestTestStepInput$ = [4, n2, _ATTSIu,
    0,
    [_tH, _rIu, _rIun, _aIl, _cR, _we, _che, _jC, _j, _cTu, _tTE, _fl, _py, _sPT, _jN, _rIN, _out, _tUF, _sn, _iTo, _sM, _rM, _sMu, _cST, _nM, _pM, _qui, _cQ, _pEQ, _mc, _sAQ, _pro],
    [() => AutoTestTestHideStepInput$, () => AutoTestRunInStepInput$, () => AutoTestRunIfStepInput$, () => AutoTestAllowInternetStepInput$, () => AutoTestConnectRubricStepInput$, () => AutoTestWeightStepInput$, () => AutoTestCheckstyleStepInput$, () => AutoTestJavaCompileStepInput$, () => AutoTestJunit5StepInput$, () => AutoTestCustomTestStepInput$, () => AutoTestTestTimeoutEachStepInput$, () => AutoTestFlake8StepInput$, () => AutoTestPytestStepInput$, () => AutoTestSimplePythonTestStepInput$, () => AutoTestJupyterNotebookStepInput$, () => AutoTestRunInNotebookStepInput$, () => AutoTestOutputStepInput$, () => AutoTestTestUploadFilesStepInput$, () => AutoTestSnapshotStepInput$, () => AutoTestIoTestStepInput$, () => AutoTestSimpleMatchStepInput$, () => AutoTestRegexMatchStepInput$, () => AutoTestSubstringMatchStepInput$, () => AutoTestCodeStructureTestStepInput$, () => AutoTestNegativeMatchStepInput$, () => AutoTestPositiveMatchStepInput$, () => AutoTestQuizStepInput$, () => AutoTestCodingQuestionStepInput$, () => AutoTestPromptEngineeringQuestionStepInput$, () => AutoTestMcqStepInput$, () => AutoTestSelectAllQuestionStepInput$, () => AutoTestProgramStepInput$]
];
export var AutoTestTestStepOutput$ = [4, n2, _ATTSOu,
    0,
    [_tH, _rIu, _rIun, _aIl, _cR, _we, _che, _jC, _j, _cTu, _tTE, _fl, _py, _sPT, _jN, _rIN, _out, _tUF, _sn, _iTo, _sM, _rM, _sMu, _cST, _nM, _pM, _qui, _cQ, _pEQ, _mc, _sAQ, _pro],
    [() => AutoTestTestHideStepOutput$, () => AutoTestRunInStepOutput$, () => AutoTestRunIfStepOutput$, () => AutoTestAllowInternetStepOutput$, () => AutoTestConnectRubricStepOutput$, () => AutoTestWeightStepOutput$, () => AutoTestCheckstyleStepOutput$, () => AutoTestJavaCompileStepOutput$, () => AutoTestJunit5StepOutput$, () => AutoTestCustomTestStepOutput$, () => AutoTestTestTimeoutEachStepOutput$, () => AutoTestFlake8StepOutput$, () => AutoTestPytestStepOutput$, () => AutoTestSimplePythonTestStepOutput$, () => AutoTestJupyterNotebookStepOutput$, () => AutoTestRunInNotebookStepOutput$, () => AutoTestOutputStepOutput$, () => AutoTestTestUploadFilesStepOutput$, () => AutoTestSnapshotStepOutput$, () => AutoTestIoTestStepOutput$, () => AutoTestSimpleMatchStepOutput$, () => AutoTestRegexMatchStepOutput$, () => AutoTestSubstringMatchStepOutput$, () => AutoTestCodeStructureTestStepOutput$, () => AutoTestNegativeMatchStepOutput$, () => AutoTestPositiveMatchStepOutput$, () => AutoTestQuizStepOutput$, () => AutoTestCodingQuestionStepOutput$, () => AutoTestPromptEngineeringQuestionStepOutput$, () => AutoTestMcqStepOutput$, () => AutoTestSelectAllQuestionStepOutput$, () => AutoTestProgramStepOutput$]
];
export var User$ = [4, n3, _U,
    0,
    [_gr, _no],
    [() => GroupUser$, () => NormalUser$]
];
export var EditorFileType$ = [4, n4, _EFT,
    0,
    [_dir, _reg],
    [() => OutputEditorDirectoryType$, () => OuptutRegularFileType$]
];
export var EditorSessionSource$ = [4, n4, _ESS,
    0,
    [_tem, _sub],
    [() => EditorSessionTemplateSource$, () => EditorSessionSubmissionSource$]
];
export var InputFileType$ = [4, n4, _IFT,
    0,
    [_dir, _reg],
    [() => InputEditorDirectoryType$, () => InputRegularFileType$]
];
export var JupyterKernelStatus$ = [4, n4, _JKSu,
    0,
    [_al, _dea, _star],
    [() => JupyterKernelAlive$, () => JupyterKernelDead$, () => JupyterKernelStarting$]
];
export var JupyterMimeOutputDataEventValue$ = [4, n4, _JMODEV,
    0,
    [_inl, _li],
    [21, () => JupyterMimeOutputDataEventValueLink$]
];
export var JupyterOutputEvent$ = [4, n4, _JOE,
    0,
    [_eSx, _str, _dD, _eR, _e, _eRx, _eI],
    [() => JupyterExecuteStartOutputEvent$, () => JupyterStreamOutputEvent$, () => JupyterDisplayDataOutputEvent$, () => JupyterExecuteResultOutputEvent$, () => JupyterErrorOutputEvent$, () => JupyterExecuteReqeustedOutputEvent$, () => JupyterExecuteInterruptedOutputEvent$]
];
export var JupyterStreamOutputEventValue$ = [4, n4, _JSOEV,
    0,
    [_inl, _li],
    [21, () => JupyterStreamOutputEventValueLink$]
];
export var OuptutRegularFileType$ = [4, n4, _ORFT,
    0,
    [_tex, _bi, _qui, _not],
    [() => OutputRegularTextFileType$, () => OutputRegularBinaryFileType$, () => OutputRegularQuizFileType$, () => OutputJupyterNotebookFileType$]
];
export var BadRequestErrorReason$ = [4, n0, _BRER,
    0,
    [_wIC, _uET, _iS, _iPn, _iRO, _iNIQ, _tR],
    [() => WrongItemCountErrorReason$, () => UnknownEnumTypeErrorReason$, () => InvalidStateErrorReason$, () => InvalidParamErrorReason$, () => InexplicitRubricOverwriteReason$, () => IgnoreNonInteractedQuestions$, () => TierRestrictedErrorReason$]
];
export var NumberOfAttempts$ = [4, n5, _NOA,
    0,
    [_unl, _lim],
    [() => __Unit, 1]
];
export var PearsonQuestionData$ = [4, n5, _PQD,
    0,
    [_codi, _mC, _sA],
    [() => PearsonCodingQuestionData$, () => PearsonMultipleChoiceQuestionData$, () => PearsonSelectAllQuestionData$]
];
export var PutPearsonQuestionSource$ = [4, n5, _PPQS,
    0,
    [_codi, _mC, _sA],
    [() => PutPearsonCodingQuestionSource$, () => PearsonMultipleChoiceQuestionData$, () => PearsonSelectAllQuestionData$]
];
export var SafeProgramSource$ = [4, n6, _SPS,
    0,
    [_pQ, _sQQ, _sub],
    [() => SafeProgramPearsonQuestionSource$, () => SafeProgramSingleQuizQuestionSource$, () => SafeProgramSubmissionSource$]
];
export var CreateAssistant$ = [9, n1, _CA,
    { [_ht]: ["POST", "/assistants/", 200] }, () => CreateAssistantRequest$, () => CreateAssistantResponse$
];
export var CreateAssistantConversation$ = [9, n1, _CAC,
    { [_ht]: ["POST", "/assistants/{assistantId}/conversations/", 200] }, () => CreateAssistantConversationRequest$, () => CreateAssistantConversationResponse$
];
export var CreateAssistantMessage$ = [9, n1, _CAM,
    { [_ht]: ["POST", "/assistants/{assistantId}/conversations/{conversationId}/messages/", 200] }, () => CreateAssistantMessageRequest$, () => CreateAssistantMessageResponse$
];
export var GetAssistant$ = [9, n1, _GA,
    { [_ht]: ["GET", "/assistants/{assistantId}", 200] }, () => GetAssistantRequest$, () => GetAssistantResponse$
];
export var GetAssistantConversation$ = [9, n1, _GAC,
    { [_ht]: ["GET", "/assistants/{assistantId}/conversations/{conversationId}", 200] }, () => GetAssistantConversationRequest$, () => GetAssistantConversationResponse$
];
export var GetAssistantMessage$ = [9, n1, _GAM,
    { [_ht]: ["GET", "/assistants/{assistantId}/conversations/{conversationId}/messages/{messageId}", 200] }, () => GetAssistantMessageRequest$, () => GetAssistantMessageResponse$
];
export var ListAssignmentAssistants$ = [9, n1, _LAA,
    { [_ht]: ["GET", "/assignments/{assignmentId}/assistants/", 200] }, () => ListAssignmentAssistantsRequest$, () => ListAssignmentAssistantsResponse$
];
export var ListAssistantMessageDetails$ = [9, n1, _LAMD,
    { [_ht]: ["GET", "/assistants/{assistantId}/conversations/{conversationId}/messages/{messageId}/details/", 200] }, () => ListAssistantMessageDetailsRequest$, () => ListAssistantMessageDetailsResponse$
];
export var ListAssistantMessages$ = [9, n1, _LAM,
    { [_ht]: ["GET", "/assistantId/{assistantId}/conversations/{conversationId}/messages/", 200] }, () => ListAssistantMessagesRequest$, () => ListAssistantMessagesResponse$
];
export var ListUserAssistantConversations$ = [9, n1, _LUAC,
    { [_ht]: ["GET", "/users/{userId}/conversations/", 200] }, () => ListUserAssistantConversationsRequest$, () => ListUserAssistantConversationsResponse$
];
export var UpdateAssistant$ = [9, n1, _UA,
    { [_ht]: ["PATCH", "/assistants/{assistantId}", 200] }, () => UpdateAssistantRequest$, () => UpdateAssistantResponse$
];
export var CompleteImportAutoTestConfiguration$ = [9, n2, _CIATC,
    { [_ht]: ["POST", "/autotest/{assignmentId}/complete-import", 200] }, () => CompleteImportAutoTestConfigurationRequest$, () => CompleteImportAutoTestConfigurationResponse$
];
export var CopyAutoTestConfiguration$ = [9, n2, _CATC,
    { [_ht]: ["POST", "/autotest/{assignmentId}/copy", 200] }, () => CopyAutoTestConfigurationRequest$, () => CopyAutoTestConfigurationResponse$
];
export var CreateAutoTestSnapshot$ = [9, n2, _CATS,
    { [_ht]: ["POST", "/autotest/{assignmentId}/snapshots/", 200] }, () => CreateAutoTestSnapshotRequest$, () => CreateAutoTestSnapshotResponse$
];
export var DeleteAutoTestConfiguration$ = [9, n2, _DATC,
    { [_ht]: ["DELETE", "/autotest/{assignmentId}", 200] }, () => DeleteAutoTestConfigurationRequest$, () => DeleteAutoTestConfigurationResponse$
];
export var GetAutoTestConfiguration$ = [9, n2, _GATC,
    { [_ht]: ["GET", "/autotest/{assignmentId}", 200] }, () => GetAutoTestConfigurationRequest$, () => GetAutoTestConfigurationResponse$
];
export var GetAutoTestPublishedSnapshot$ = [9, n2, _GATPS,
    { [_ht]: ["GET", "/autotest/{assignmentId}/published-snapshot", 200] }, () => GetAutoTestPublishedSnapshotRequest$, () => GetAutoTestPublishedSnapshotResponse$
];
export var GetAutoTestRubricResults$ = [9, n2, _GATRR,
    { [_ht]: ["GET", "/autotest/{assignmentId}/rubric-results/{rubricRowId}", 200] }, () => GetAutoTestRubricResultsRequest$, () => GetAutoTestRubricResultsResponse$
];
export var GetAutoTestSnapshot$ = [9, n2, _GATS,
    { [_ht]: ["GET", "/autotest/{assignmentId}/snapshots/{snapshotId}", 200] }, () => GetAutoTestSnapshotRequest$, () => GetAutoTestSnapshotResponse$
];
export var ListAutoTestSnapshots$ = [9, n2, _LATS,
    { [_ht]: ["GET", "/autotest/{assignmentId}/snapshots/", 200] }, () => ListAutoTestSnapshotsRequest$, () => ListAutoTestSnapshotsResponse$
];
export var PutAutoTestConfiguration$ = [9, n2, _PATC,
    { [_ht]: ["PUT", "/autotest/{assignmentId}", 200] }, () => PutAutoTestConfigurationRequest$, () => PutAutoTestConfigurationResponse$
];
export var UpdateAutoTestConfiguration$ = [9, n2, _UATC,
    { [_ht]: ["PATCH", "/autotest/{assignmentId}", 200] }, () => UpdateAutoTestConfigurationRequest$, () => UpdateAutoTestConfigurationResponse$
];
export var CreateEditorSession$ = [9, n4, _CES,
    { [_ht]: ["POST", "/editor-sessions/", 200] }, () => CreateEditorSessionRequest$, () => CreateEditorSessionResponse$
];
export var ExecuteEditorDocumentJupyterCell$ = [9, n4, _EEDJC,
    { [_ht]: ["POST", "/editor-documents/{documentId}/jupyter-cells/{cellId}/execute", 200] }, () => ExecuteEditorDocumentJupyterCellRequest$, () => ExecuteEditorDocumentJupyterCellResponse$
];
export var GetEditorDocument$ = [9, n4, _GED,
    { [_ht]: ["GET", "/editor-documents/{documentId}", 200] }, () => GetEditorDocumentRequest$, () => GetEditorDocumentResponse$
];
export var GetEditorFileDownloadLink$ = [9, n4, _GEFDL,
    { [_ht]: ["GET", "/editor-sessions/{editorSessionId}/file", 200] }, () => GetEditorFileDownloadLinkRequest$, () => GetEditorFileDownloadLinkResponse$
];
export var GetEditorSession$ = [9, n4, _GES,
    { [_ht]: ["GET", "/editor-sessions/{editorSessionId}", 200] }, () => GetEditorSessionRequest$, () => GetEditorSessionResponse$
];
export var HandInEditorSession$ = [9, n4, _HIES,
    { [_ht]: ["POST", "/editors-sessions/{editorSessionId}/hand-in", 200] }, () => HandInEditorSessionRequest$, () => HandInEditorSessionResponse$
];
export var InterruptEditorDocumentJupyterKernel$ = [9, n4, _IEDJK,
    { [_ht]: ["POST", "/editor-documents/{documentId}/interrupt", 200] }, () => InterruptEditorDocumentJupyterKernelRequest$, () => InterruptEditorDocumentJupyterKernelResponse$
];
export var ListEditorDocumentJupyterCellOutputs$ = [9, n4, _LEDJCO,
    { [_ht]: ["GET", "/editor-documents/{documentId}/jupyter-cells/{cellId}/outputs/", 200] }, () => ListEditorDocumentJupyterCellOutputsRequest$, () => ListEditorDocumentJupyterCellOutputsResponse$
];
export var ListEditorDocuments$ = [9, n4, _LED,
    { [_ht]: ["GET", "/editor-sessions/{editorSessionId}/documents/", 200] }, () => ListEditorDocumentsRequest$, () => ListEditorDocumentsResponse$
];
export var ListEditorSessions$ = [9, n4, _LES,
    { [_ht]: ["GET", "/users/{userId}/editor-sessions/", 200] }, () => ListEditorSessionsRequest$, () => ListEditorSessionsResponse$
];
export var PutEditorFile$ = [9, n4, _PEF,
    { [_ht]: ["PUT", "/editor-sessions/{editorSessionId}/files/", 200] }, () => PutEditorFileRequest$, () => PutEditorFileResponse$
];
export var GetPearsonContextTemplate$ = [9, n5, _GPCT,
    { [_ht]: ["GET", "/tenants/{tenantId}/pearson-templates/{templateId}/courses/{contextId}", 200] }, () => GetPearsonContextTemplateRequest$, () => GetPearsonContextTemplateResponse$
];
export var GetPearsonContextTemplateQuestion$ = [9, n5, _GPCTQ,
    { [_ht]: ["GET", "/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}/questions/{questionId}", 200] }, () => GetPearsonContextTemplateQuestionRequest$, () => GetPearsonContextTemplateQuestionResponse$
];
export var InstantiatePearsonTemplate$ = [9, n5, _IPT,
    { [_ht]: ["PUT", "/tenants/{tenantId}/pearson-templates/{templateId}/instantiate", 200] }, () => InstantiatePearsonTemplateRequest$, () => InstantiatePearsonTemplateResponse$
];
export var PutPearsonBook$ = [9, n5, _PPB,
    { [_ht]: ["PUT", "/tenants/{tenantId}/pearson-books/{bookId}", 200] }, () => PutPearsonBookRequest$, () => PutPearsonBookResponse$
];
export var PutPearsonContextTemplate$ = [9, n5, _PPCT,
    { [_ht]: ["PUT", "/tenants/{tenantId}/pearson-templates/{templateId}/courses/{contextId}", 200] }, () => PutPearsonContextTemplateRequest$, () => PutPearsonContextTemplateResponse$
];
export var PutPearsonQuestion$ = [9, n5, _PPQ,
    { [_ht]: ["PUT", "/tenants/{tenantId}/pearson-templates/{templateId}/questions/{questionId}", 200] }, () => PutPearsonQuestionRequest$, () => PutPearsonQuestionResponse$
];
export var PutPearsonTemplate$ = [9, n5, _PPT,
    { [_ht]: ["PUT", "/tenants/{tenantId}/pearson-templates/{templateId}", 200] }, () => PutPearsonTemplateRequest$, () => PutPearsonTemplateResponse$
];
export var UpdatePearsonContextTemplate$ = [9, n5, _UPCT,
    { [_ht]: ["PATCH", "/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}", 200] }, () => UpdatePearsonContextTemplateRequest$, () => UpdatePearsonContextTemplateResponse$
];
export var UpdatePearsonContextTemplateQuestion$ = [9, n5, _UPCTQ,
    { [_ht]: ["PATCH", "/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}/questions/{questionId}", 200] }, () => UpdatePearsonContextTemplateQuestionRequest$, () => UpdatePearsonContextTemplateQuestionResponse$
];
export var CreateSafeProgram$ = [9, n6, _CSP,
    { [_ht]: ["POST", "/safe-program/", 200] }, () => CreateSafeProgramRequest$, () => CreateSafeProgramResponse$
];
